export interface ITimezone {
  timerect: number;
  timereftime: number;
  country: string;
  timestate: string;
  timecity: string;
  timediff: number;
  timeZoneTimeAbbreviation: string;
  iana_timezone: string;
}

export const timezonesData: ITimezone[] = [
  {
    timerect: 1000,
    timereftime: 113,
    country: "Afghanistan",
    timestate: "",
    timecity: "Kabul",
    timediff: 270,
    timeZoneTimeAbbreviation: "AsiaAFT",
    iana_timezone: "Asia/Kabul",
  },
  {
    timerect: 1001,
    timereftime: 154,
    country: "Mexico",
    timestate: "",
    timecity: "Mexicali",
    timediff: -480,
    timeZoneTimeAbbreviation: "AmericaPDT",
    iana_timezone: "America/Tijuana",
  },
  {
    timerect: 1002,
    timereftime: 284,
    country: "Albania",
    timestate: "",
    timecity: "Tirane",
    timediff: 60,
    timeZoneTimeAbbreviation: "EuropeCEST",
    iana_timezone: "Europe/Tirane",
  },
  {
    timerect: 1003,
    timereftime: 155,
    country: "Mexico",
    timestate: "",
    timecity: "Mexico City",
    timediff: -360,
    timeZoneTimeAbbreviation: "AmericaCST",
    iana_timezone: "America/Mexico_City",
  },
  {
    timerect: 1004,
    timereftime: 14,
    country: "Algeria",
    timestate: "",
    timecity: "Algiers",
    timediff: 60,
    timeZoneTimeAbbreviation: "AfricaCET",
    iana_timezone: "Africa/Algiers",
  },
  {
    timerect: 1005,
    timereftime: 162,
    country: "Mexico",
    timestate: "",
    timecity: "Monterrey",
    timediff: -360,
    timeZoneTimeAbbreviation: "AmericaCDT",
    iana_timezone: "America/Monterrey",
  },
  {
    timerect: 1006,
    timereftime: 686,
    country: "Andorra",
    timestate: "",
    timecity: "Andorra La Vella",
    timediff: 60,
    timeZoneTimeAbbreviation: "EuropeCET",
    iana_timezone: "Europe/Andorra",
  },
  {
    timerect: 1007,
    timereftime: 227,
    country: "Mexico",
    timestate: "",
    timecity: "San Luis Potosi",
    timediff: -360,
    timeZoneTimeAbbreviation: "AmericaCST",
    iana_timezone: "America/San_Luis_Potosi",
  },
  {
    timerect: 1008,
    timereftime: 138,
    country: "Angola",
    timestate: "",
    timecity: "Luanda",
    timediff: 60,
    timeZoneTimeAbbreviation: "AfricaWAT",
    iana_timezone: "Africa/Luanda",
  },
  {
    timerect: 1009,
    timereftime: 247,
    country: "Mexico",
    timestate: "",
    timecity: "Tijuana",
    timediff: -480,
    timeZoneTimeAbbreviation: "AmericaPDT",
    iana_timezone: "America/Tijuana",
  },
  {
    timerect: 1010,
    timereftime: 688,
    country: "Antigua and Barbuda",
    timestate: "",
    timecity: "Saint John's",
    timediff: -240,
    timeZoneTimeAbbreviation: "AmericaAST",
    iana_timezone: "America/Antigua",
  },
  {
    timerect: 1011,
    timereftime: 258,
    country: "Mexico",
    timestate: "",
    timecity: "Veracruz",
    timediff: -360,
    timeZoneTimeAbbreviation: "AmericaCST",
    iana_timezone: "America/Veracruz",
  },
  {
    timerect: 1012,
    timereftime: 51,
    country: "Argentina",
    timestate: "",
    timecity: "Buenos Aires",
    timediff: -180,
    timeZoneTimeAbbreviation: "AmericaART",
    iana_timezone: "America/Argentina/Buenos_Aires",
  },
  {
    timerect: 1013,
    timereftime: 1072,
    country: "Micronesia",
    timestate: "Ponape",
    timecity: "Palikir",
    timediff: 660,
    timeZoneTimeAbbreviation: "PacificPONT",
    iana_timezone: "Pacific/Pohnpei",
  },
  {
    timerect: 1014,
    timereftime: 541,
    country: "Argentina",
    timestate: "Buenos Aires",
    timecity: "La Plata",
    timediff: -180,
    timeZoneTimeAbbreviation: "AmericaART",
    iana_timezone: "America/Argentina/Buenos_Aires",
  },
  {
    timerect: 1015,
    timereftime: 177,
    country: "Moldova",
    timestate: "",
    timecity: "Kishinev",
    timediff: 120,
    timeZoneTimeAbbreviation: "EuropeEET",
    iana_timezone: "Europe/Chisinau",
  },
  {
    timerect: 1016,
    timereftime: 558,
    country: "Argentina",
    timestate: "Buenos Aires",
    timecity: "Mar del Plata",
    timediff: -180,
    timeZoneTimeAbbreviation: "AmericaART",
    iana_timezone: "America/Argentina/Buenos_Aires",
  },
  {
    timerect: 1017,
    timereftime: 674,
    country: "Monaco",
    timestate: "",
    timecity: "Monaco",
    timediff: 60,
    timeZoneTimeAbbreviation: "EuropeCEST",
    iana_timezone: "Europe/Monaco",
  },
  {
    timerect: 1018,
    timereftime: 562,
    country: "Argentina",
    timestate: "Mendoza",
    timecity: "Mendoza",
    timediff: -180,
    timeZoneTimeAbbreviation: "AmericaART",
    iana_timezone: "America/Argentina/Mendoza",
  },
  {
    timerect: 1019,
    timereftime: 1026,
    country: "Mongolia",
    timestate: "",
    timecity: "Choibalsan",
    timediff: 480,
    timeZoneTimeAbbreviation: "AsiaCHOT",
    iana_timezone: "Asia/Choibalsan",
  },
  {
    timerect: 1020,
    timereftime: 606,
    country: "Argentina",
    timestate: "Salta",
    timecity: "Salta",
    timediff: -180,
    timeZoneTimeAbbreviation: "AmericaART",
    iana_timezone: "America/Argentina/Salta",
  },
  {
    timerect: 1021,
    timereftime: 950,
    country: "Mongolia",
    timestate: "",
    timecity: "Hovd",
    timediff: 420,
    timeZoneTimeAbbreviation: "AsiaHOVT",
    iana_timezone: "Asia/Hovd",
  },
  {
    timerect: 1022,
    timereftime: 1079,
    country: "Argentina",
    timestate: "Santa Fé",
    timecity: "Rosario",
    timediff: -180,
    timeZoneTimeAbbreviation: "AmericaART",
    iana_timezone: "America/Argentina/Cordoba", // Rosario usa el mismo que Cordoba
  },
  {
    timerect: 1023,
    timereftime: 720,
    country: "Mongolia",
    timestate: "",
    timecity: "Ulaanbaatar",
    timediff: 480,
    timeZoneTimeAbbreviation: "AsiaCHOT",
    iana_timezone: "Asia/Ulaanbaatar",
  },
  {
    timerect: 1024,
    timereftime: 650,
    country: "Argentina",
    timestate: "Tucumán",
    timecity: "Tucumán",
    timediff: -180,
    timeZoneTimeAbbreviation: "AmericaART",
    iana_timezone: "America/Argentina/Tucuman",
  },
  {
    timerect: 1025,
    timereftime: 60,
    country: "Morocco",
    timestate: "",
    timecity: "Casablanca",
    timediff: 0,
    timeZoneTimeAbbreviation: "AfricaWEST",
    iana_timezone: "Africa/Casablanca",
  },
  {
    timerect: 1026,
    timereftime: 370,
    country: "Armenia",
    timestate: "",
    timecity: "Yerevan",
    timediff: 240,
    timeZoneTimeAbbreviation: "AsiaAMT",
    iana_timezone: "Asia/Yerevan",
  },
  {
    timerect: 1027,
    timereftime: 206,
    country: "Morocco",
    timestate: "",
    timecity: "Rabat",
    timediff: 0,
    timeZoneTimeAbbreviation: "AfricaWEST",
    iana_timezone: "Africa/Casablanca",
  },
  {
    timerect: 1028,
    timereftime: 57,
    country: "Australia",
    timestate: "Australian Capital Territory",
    timecity: "Canberra",
    timediff: 660,
    timeZoneTimeAbbreviation: "AustraliaAEDT",
    iana_timezone: "Australia/Sydney",
  },
  {
    timerect: 1029,
    timereftime: 243,
    country: "Morocco",
    timestate: "",
    timecity: "Tanger",
    timediff: 0,
    timeZoneTimeAbbreviation: "AfricaWEST",
    iana_timezone: "Africa/Casablanca",
  },
  {
    timerect: 1030,
    timereftime: 695,
    country: "Australia",
    timestate: "Christmas Island",
    timecity: "The Settlement",
    timediff: 420,
    timeZoneTimeAbbreviation: "AustraliaCXT",
    iana_timezone: "Indian/Christmas",
  },
  {
    timerect: 1031,
    timereftime: 146,
    country: "Mozambique",
    timestate: "",
    timecity: "Maputo",
    timediff: 120,
    timeZoneTimeAbbreviation: "AfricaCAT",
    iana_timezone: "Africa/Maputo",
  },
  {
    timerect: 1032,
    timereftime: 750,
    country: "Australia",
    timestate: "Lord Howe Island",
    timecity: "Lord Howe Island",
    timediff: 660,
    timeZoneTimeAbbreviation: "AustraliaLHDT",
    iana_timezone: "Australia/Lord_Howe",
  },
  {
    timerect: 1033,
    timereftime: 208,
    country: "Myanmar",
    timestate: "",
    timecity: "Yangon",
    timediff: 390,
    timeZoneTimeAbbreviation: "AsiaMMT",
    iana_timezone: "Asia/Yangon",
  },
  {
    timerect: 1034,
    timereftime: 240,
    country: "Australia",
    timestate: "New South Wales",
    timecity: "Sydney",
    timediff: 660,
    timeZoneTimeAbbreviation: "AustraliaAEDT",
    iana_timezone: "Australia/Sydney",
  },
  {
    timerect: 1035,
    timereftime: 266,
    country: "Namibia",
    timestate: "",
    timecity: "Windhoek",
    timediff: 120,
    timeZoneTimeAbbreviation: "AfricaCAT",
    iana_timezone: "Africa/Windhoek",
  },
  {
    timerect: 1036,
    timereftime: 725,
    country: "Australia",
    timestate: "Norfolk Island",
    timecity: "Kingston",
    timediff: 690,
    timeZoneTimeAbbreviation: "AustraliaNFT",
    iana_timezone: "Pacific/Norfolk",
  },
  {
    timerect: 1037,
    timereftime: 276,
    country: "Nauru",
    timestate: "",
    timecity: "Makwa",
    timediff: 720,
    timeZoneTimeAbbreviation: "PacificNRT",
    iana_timezone: "Pacific/Nauru",
  },
  {
    timerect: 1038,
    timereftime: 72,
    country: "Australia",
    timestate: "Northern Territory",
    timecity: "Darwin",
    timediff: 570,
    timeZoneTimeAbbreviation: "AustraliaACST",
    iana_timezone: "Australia/Darwin",
  },
  {
    timerect: 1039,
    timereftime: 117,
    country: "Nepal",
    timestate: "",
    timecity: "Kathmandu",
    timediff: 345,
    timeZoneTimeAbbreviation: "AsiaNPT",
    iana_timezone: "Asia/Kathmandu",
  },
  {
    timerect: 1040,
    timereftime: 47,
    country: "Australia",
    timestate: "Queensland",
    timecity: "Brisbane",
    timediff: 600,
    timeZoneTimeAbbreviation: "AustraliaAEST",
    iana_timezone: "Australia/Brisbane",
  },
  {
    timerect: 1041,
    timereftime: 16,
    country: "Netherlands",
    timestate: "",
    timecity: "Amsterdam",
    timediff: 60,
    timeZoneTimeAbbreviation: "EuropeCEST",
    iana_timezone: "Europe/Amsterdam",
  },
  {
    timerect: 1042,
    timereftime: 5,
    country: "Australia",
    timestate: "South Australia",
    timecity: "Adelaide",
    timediff: 630,
    timeZoneTimeAbbreviation: "AustraliaACDT",
    iana_timezone: "Australia/Adelaide",
  },
  {
    timerect: 1043,
    timereftime: 689,
    country: "Aruba",
    timestate: "Aruba",
    timecity: "Oranjestad",
    timediff: -240,
    timeZoneTimeAbbreviation: "AmericaAST",
    iana_timezone: "America/Aruba",
  },
  {
    timerect: 1044,
    timereftime: 396,
    country: "Australia",
    timestate: "Tasmania",
    timecity: "Hobart",
    timediff: 660,
    timeZoneTimeAbbreviation: "AustraliaAEDT",
    iana_timezone: "Australia/Hobart",
  },
  {
    timerect: 1045,
    timereftime: 338,
    country: "Netherlands",
    timestate: "",
    timecity: "Rotterdam",
    timediff: 60,
    timeZoneTimeAbbreviation: "EuropeCET",
    iana_timezone: "Europe/Amsterdam",
  },
  {
    timerect: 1046,
    timereftime: 152,
    country: "Australia",
    timestate: "Victoria",
    timecity: "Melbourne",
    timediff: 660,
    timeZoneTimeAbbreviation: "AustraliaAEDT",
    iana_timezone: "Australia/Melbourne",
  },
  {
    timerect: 1047,
    timereftime: 722,
    country: "Netherlands",
    timestate: "Netherlands Antilles",
    timecity: "Willemstad",
    timediff: -240,
    timeZoneTimeAbbreviation: "EuropeAST",
    iana_timezone: "America/Curacao",
  },
  {
    timerect: 1048,
    timereftime: 196,
    country: "Australia",
    timestate: "Western Australia",
    timecity: "Perth",
    timediff: 480,
    timeZoneTimeAbbreviation: "AustraliaAWST",
    iana_timezone: "Australia/Perth",
  },
  {
    timerect: 1049,
    timereftime: 22,
    country: "New Zealand",
    timestate: "",
    timecity: "Auckland",
    timediff: 780,
    timeZoneTimeAbbreviation: "AustraliaNZDT",
    iana_timezone: "Pacific/Auckland",
  },
  {
    timerect: 1050,
    timereftime: 223,
    country: "Austria",
    timestate: "",
    timecity: "Salzburg",
    timediff: 60,
    timeZoneTimeAbbreviation: "EuropeCET",
    iana_timezone: "Europe/Vienna",
  },
  {
    timerect: 1051,
    timereftime: 63,
    country: "New Zealand",
    timestate: "",
    timecity: "Chatham Island",
    timediff: 825,
    timeZoneTimeAbbreviation: "AustraliaCHAST",
    iana_timezone: "Pacific/Chatham",
  },
  {
    timerect: 1052,
    timereftime: 259,
    country: "Austria",
    timestate: "",
    timecity: "Vienna",
    timediff: 60,
    timeZoneTimeAbbreviation: "EuropeCEST",
    iana_timezone: "Europe/Vienna",
  },
  {
    timerect: 1053,
    timereftime: 951,
    country: "New Zealand",
    timestate: "",
    timecity: "Christchurch",
    timediff: 780,
    timeZoneTimeAbbreviation: "AustraliaNZDT",
    iana_timezone: "Pacific/Auckland",
  },
  {
    timerect: 1054,
    timereftime: 369,
    country: "Azerbaijan",
    timestate: "",
    timecity: "Baku",
    timediff: 240,
    timeZoneTimeAbbreviation: "AsiaAZT",
    iana_timezone: "Asia/Baku",
  },
  {
    timerect: 1055,
    timereftime: 264,
    country: "New Zealand",
    timestate: "",
    timecity: "Wellington",
    timediff: 780,
    timeZoneTimeAbbreviation: "AustraliaNZDT",
    iana_timezone: "Pacific/Auckland",
  },
  {
    timerect: 1056,
    timereftime: 173,
    country: "Bahamas",
    timestate: "",
    timecity: "Nassau",
    timediff: -300,
    timeZoneTimeAbbreviation: "AmericaEDT",
    iana_timezone: "America/Nassau",
  },
  {
    timerect: 1057,
    timereftime: 143,
    country: "Nicaragua",
    timestate: "",
    timecity: "Managua",
    timediff: -360,
    timeZoneTimeAbbreviation: "AmericaCST",
    iana_timezone: "America/Managua",
  },
  {
    timerect: 1058,
    timereftime: 15,
    country: "Bahrain",
    timestate: "",
    timecity: "Al Manamah",
    timediff: 180,
    timeZoneTimeAbbreviation: "AsiaAST",
    iana_timezone: "Asia/Bahrain",
  },
  {
    timerect: 1059,
    timereftime: 180,
    country: "Niger",
    timestate: "",
    timecity: "Niamey",
    timediff: 60,
    timeZoneTimeAbbreviation: "AfricaWAT",
    iana_timezone: "Africa/Niamey",
  },
  {
    timerect: 1060,
    timereftime: 469,
    country: "Bangladesh",
    timestate: "",
    timecity: "Chittagong",
    timediff: 360,
    timeZoneTimeAbbreviation: "AsiaBST",
    iana_timezone: "Asia/Dhaka",
  },
  {
    timerect: 1061,
    timereftime: 742,
    country: "Nigeria",
    timestate: "",
    timecity: "Abuja",
    timediff: 60,
    timeZoneTimeAbbreviation: "AfricaWAT",
    iana_timezone: "Africa/Lagos",
  },
  {
    timerect: 1062,
    timereftime: 73,
    country: "Bangladesh",
    timestate: "",
    timecity: "Dhaka",
    timediff: 360,
    timeZoneTimeAbbreviation: "AsiaBST",
    iana_timezone: "Asia/Dhaka",
  },
  {
    timerect: 1063,
    timereftime: 116,
    country: "Nigeria",
    timestate: "",
    timecity: "Kano Nigeria",
    timediff: 60,
    timeZoneTimeAbbreviation: "AfricaWAT",
    iana_timezone: "Africa/Lagos",
  },
  {
    timerect: 1064,
    timereftime: 943,
    country: "Bangladesh",
    timestate: "",
    timecity: "Khulna",
    timediff: 360,
    timeZoneTimeAbbreviation: "AsiaBST",
    iana_timezone: "Asia/Dhaka",
  },
  {
    timerect: 1065,
    timereftime: 125,
    country: "Nigeria",
    timestate: "",
    timecity: "Lagos",
    timediff: 60,
    timeZoneTimeAbbreviation: "AfricaWAT",
    iana_timezone: "Africa/Lagos",
  },
  {
    timerect: 1066,
    timereftime: 46,
    country: "Barbados",
    timestate: "",
    timecity: "Bridgetown",
    timediff: -240,
    timeZoneTimeAbbreviation: "AtlanticAST",
    iana_timezone: "America/Barbados",
  },
  {
    timerect: 1067,
    timereftime: 724,
    country: "Niue",
    timestate: "",
    timecity: "Alofi",
    timediff: -660,
    timeZoneTimeAbbreviation: "PacificNUT",
    iana_timezone: "Pacific/Niue",
  },
  {
    timerect: 1068,
    timereftime: 285,
    country: "Belarus",
    timestate: "",
    timecity: "Minsk",
    timediff: 180,
    timeZoneTimeAbbreviation: "EuropeFET",
    iana_timezone: "Europe/Minsk",
  },
  {
    timerect: 1069,
    timereftime: 205,
    country: "North Korea",
    timestate: "",
    timecity: "Pyongyang",
    timediff: 540,
    timeZoneTimeAbbreviation: "AsiaKST",
    iana_timezone: "Asia/Pyongyang",
  },
  {
    timerect: 1070,
    timereftime: 48,
    country: "Belgium",
    timestate: "",
    timecity: "Brussels",
    timediff: 60,
    timeZoneTimeAbbreviation: "EuropeCEST",
    iana_timezone: "Europe/Brussels",
  },
  {
    timerect: 1071,
    timereftime: 187,
    country: "Norway",
    timestate: "",
    timecity: "Oslo",
    timediff: 60,
    timeZoneTimeAbbreviation: "EuropeCEST",
    iana_timezone: "Europe/Oslo",
  },
  {
    timerect: 1072,
    timereftime: 36,
    country: "Belize",
    timestate: "",
    timecity: "Belmopan",
    timediff: -360,
    timeZoneTimeAbbreviation: "AmericaCST",
    iana_timezone: "America/Belize",
  },
  {
    timerect: 1073,
    timereftime: 169,
    country: "Oman",
    timestate: "",
    timecity: "Muscat",
    timediff: 240,
    timeZoneTimeAbbreviation: "AsiaGST",
    iana_timezone: "Asia/Muscat",
  },
  {
    timerect: 1074,
    timereftime: 203,
    country: "Benin",
    timestate: "",
    timecity: "Porto Novo",
    timediff: 60,
    timeZoneTimeAbbreviation: "AfricaWAT",
    iana_timezone: "Africa/Porto-Novo",
  },
  {
    timerect: 1075,
    timereftime: 758,
    country: "Pakistan",
    timestate: "",
    timecity: "Faisalabad",
    timediff: 300,
    timeZoneTimeAbbreviation: "AsiaPKT",
    iana_timezone: "Asia/Karachi",
  },
  {
    timerect: 1076,
    timereftime: 690,
    country: "Bhutan",
    timestate: "",
    timecity: "Thimphu",
    timediff: 360,
    timeZoneTimeAbbreviation: "AsiaBTT",
    iana_timezone: "Asia/Thimphu",
  },
  {
    timerect: 1077,
    timereftime: 106,
    country: "Pakistan",
    timestate: "",
    timecity: "Islamabad",
    timediff: 300,
    timeZoneTimeAbbreviation: "AsiaPKT",
    iana_timezone: "Asia/Karachi",
  },
  {
    timerect: 1078,
    timereftime: 124,
    country: "Bolivia",
    timestate: "",
    timecity: "La Paz",
    timediff: -240,
    timeZoneTimeAbbreviation: "AmericaBOT",
    iana_timezone: "America/La_Paz",
  },
  {
    timerect: 1079,
    timereftime: 757,
    country: "Pakistan",
    timestate: "",
    timecity: "Karachi",
    timediff: 300,
    timeZoneTimeAbbreviation: "AsiaPKT",
    iana_timezone: "Asia/Karachi",
  },
  {
    timerect: 1080,
    timereftime: 691,
    country: "Bosnia Herzegovina",
    timestate: "",
    timecity: "Sarajevo",
    timediff: 60,
    timeZoneTimeAbbreviation: "EuropeCEST",
    iana_timezone: "Europe/Sarajevo",
  },
  {
    timerect: 1081,
    timereftime: 756,
    country: "Pakistan",
    timestate: "",
    timecity: "Lahore",
    timediff: 300,
    timeZoneTimeAbbreviation: "AsiaPKT",
    iana_timezone: "Asia/Karachi",
  },
  {
    timerect: 1082,
    timereftime: 86,
    country: "Botswana",
    timestate: "",
    timecity: "Gaborone",
    timediff: 120,
    timeZoneTimeAbbreviation: "AfricaCAT",
    iana_timezone: "Africa/Gaborone",
  },
  {
    timerect: 1083,
    timereftime: 726,
    country: "Palau",
    timestate: "",
    timecity: "Koror",
    timediff: 540,
    timeZoneTimeAbbreviation: "PacificPWT",
    iana_timezone: "Pacific/Palau",
  },
  {
    timerect: 1084,
    timereftime: 752,
    country: "Brazil",
    timestate: "Acre",
    timecity: "Rio Branco",
    timediff: -240,
    timeZoneTimeAbbreviation: "AmericaACT",
    iana_timezone: "America/Rio_Branco",
  },
  {
    timerect: 1085,
    timereftime: 192,
    country: "Panama",
    timestate: "",
    timecity: "Panama",
    timediff: -300,
    timeZoneTimeAbbreviation: "AmericaEST",
    iana_timezone: "America/Panama",
  },
  {
    timerect: 1086,
    timereftime: 144,
    country: "Brazil",
    timestate: "Amazonas",
    timecity: "Manaus",
    timediff: -240,
    timeZoneTimeAbbreviation: "AmericaAMT",
    iana_timezone: "America/Manaus",
  },
  {
    timerect: 1087,
    timereftime: 193,
    country: "Papua New Guinea",
    timestate: "",
    timecity: "Port Moresby",
    timediff: 600,
    timeZoneTimeAbbreviation: "AustraliaPGT",
    iana_timezone: "Pacific/Port_Moresby",
  },
  {
    timerect: 1088,
    timereftime: 222,
    country: "Brazil",
    timestate: "Bahia",
    timecity: "Salvador",
    timediff: -180,
    timeZoneTimeAbbreviation: "AmericaBRT",
    iana_timezone: "America/Salvador",
  },
  {
    timerect: 1089,
    timereftime: 21,
    country: "Paraguay",
    timestate: "",
    timecity: "Asuncion",
    timediff: -180,
    timeZoneTimeAbbreviation: "AmericaPYT",
    iana_timezone: "America/Asuncion",
  },
  {
    timerect: 1090,
    timereftime: 45,
    country: "Brazil",
    timestate: "Distrito Federal",
    timecity: "Brasilia",
    timediff: -120,
    timeZoneTimeAbbreviation: "AmericaBRT",
    iana_timezone: "America/Sao_Paulo",
  },
  {
    timerect: 1091,
    timereftime: 131,
    country: "Peru",
    timestate: "",
    timecity: "Lima",
    timediff: -300,
    timeZoneTimeAbbreviation: "AmericaPET",
    iana_timezone: "America/Lima",
  },
  {
    timerect: 1092,
    timereftime: 751,
    country: "Brazil",
    timestate: "Pernambuco",
    timecity: "Fernando de Noronha",
    timediff: -120,
    timeZoneTimeAbbreviation: "AmericaFNT",
    iana_timezone: "America/Noronha",
  },
  {
    timerect: 1093,
    timereftime: 145,
    country: "Philippines",
    timestate: "",
    timecity: "Manila",
    timediff: 480,
    timeZoneTimeAbbreviation: "AsiaPST",
    iana_timezone: "Asia/Manila",
  },
  {
    timerect: 1094,
    timereftime: 209,
    country: "Brazil",
    timestate: "Pernambuco",
    timecity: "Recife",
    timediff: -180,
    timeZoneTimeAbbreviation: "AmericaBRT",
    iana_timezone: "America/Recife",
  },
  {
    timerect: 1095,
    timereftime: 496,
    country: "Poland",
    timestate: "",
    timecity: "Gdansk",
    timediff: 60,
    timeZoneTimeAbbreviation: "EuropeCET",
    iana_timezone: "Europe/Warsaw",
  },
  {
    timerect: 1096,
    timereftime: 213,
    country: "Brazil",
    timestate: "Rio de Janeiro",
    timecity: "Rio de Janeiro",
    timediff: -120,
    timeZoneTimeAbbreviation: "AmericaBRT",
    iana_timezone: "America/Sao_Paulo",
  },
  {
    timerect: 1097,
    timereftime: 535,
    country: "Poland",
    timestate: "",
    timecity: "Kraków",
    timediff: 60,
    timeZoneTimeAbbreviation: "EuropeCET",
    iana_timezone: "Europe/Warsaw",
  },
  {
    timerect: 1098,
    timereftime: 595,
    country: "Brazil",
    timestate: "Rio Grande do Sul",
    timecity: "Pôrto Alegre",
    timediff: -180,
    timeZoneTimeAbbreviation: "AmericaBRT",
    iana_timezone: "America/Sao_Paulo",
  },
  {
    timerect: 1099,
    timereftime: 548,
    country: "Poland",
    timestate: "",
    timecity: "Lódz",
    timediff: 60,
    timeZoneTimeAbbreviation: "EuropeCET",
    iana_timezone: "Europe/Warsaw",
  },
  {
    timerect: 1100,
    timereftime: 233,
    country: "Brazil",
    timestate: "São Paulo",
    timecity: "Sao Paulo",
    timediff: -120,
    timeZoneTimeAbbreviation: "AmericaBRT",
    iana_timezone: "America/Sao_Paulo",
  },
  {
    timerect: 1101,
    timereftime: 591,
    country: "Poland",
    timestate: "",
    timecity: "Poznan",
    timediff: 60,
    timeZoneTimeAbbreviation: "EuropeCET",
    iana_timezone: "Europe/Warsaw",
  },
  {
    timerect: 1102,
    timereftime: 693,
    country: "Brunei Darussalam",
    timestate: "",
    timecity: "Bandar Seri Begawan",
    timediff: 480,
    timeZoneTimeAbbreviation: "AsiaBNT",
    iana_timezone: "Asia/Brunei",
  },
  {
    timerect: 1103,
    timereftime: 633,
    country: "Poland",
    timestate: "",
    timecity: "Szczecin",
    timediff: 60,
    timeZoneTimeAbbreviation: "EuropeCET",
    iana_timezone: "Europe/Warsaw",
  },
  {
    timerect: 1104,
    timereftime: 238,
    country: "Bulgaria",
    timestate: "",
    timecity: "Sofia",
    timediff: 120,
    timeZoneTimeAbbreviation: "EuropeEEST",
    iana_timezone: "Europe/Sofia",
  },
  {
    timerect: 1105,
    timereftime: 262,
    country: "Poland",
    timestate: "",
    timecity: "Warsaw",
    timediff: 60,
    timeZoneTimeAbbreviation: "EuropeCEST",
    iana_timezone: "Europe/Warsaw",
  },
  {
    timerect: 1106,
    timereftime: 186,
    country: "Burkina Faso",
    timestate: "",
    timecity: "Ouagadougou",
    timediff: 0,
    timeZoneTimeAbbreviation: "AfricaGMT",
    iana_timezone: "Africa/Ouagadougou",
  },
  {
    timerect: 1107,
    timereftime: 664,
    country: "Poland",
    timestate: "",
    timecity: "Wroclaw",
    timediff: 60,
    timeZoneTimeAbbreviation: "EuropeCET",
    iana_timezone: "Europe/Warsaw",
  },
  {
    timerect: 1108,
    timereftime: 52,
    country: "Burundi",
    timestate: "",
    timecity: "Bujumbura",
    timediff: 120,
    timeZoneTimeAbbreviation: "AfricaCAT",
    iana_timezone: "Africa/Bujumbura",
  },
  {
    timerect: 1109,
    timereftime: 271,
    country: "Portugal",
    timestate: "Azores",
    timecity: "Azores",
    timediff: -60,
    timeZoneTimeAbbreviation: "AtlanticAZOST",
    iana_timezone: "Atlantic/Azores",
  },
  {
    timerect: 1110,
    timereftime: 199,
    country: "Cambodia",
    timestate: "",
    timecity: "Phnom Penh",
    timediff: 420,
    timeZoneTimeAbbreviation: "AsiaICT",
    iana_timezone: "Asia/Phnom_Penh",
  },
  {
    timerect: 1111,
    timereftime: 682,
    country: "Portugal",
    timestate: "Madeira",
    timecity: "Funchal",
    timediff: 0,
    timeZoneTimeAbbreviation: "EuropeWET",
    iana_timezone: "Atlantic/Madeira",
  },
  {
    timerect: 1112,
    timereftime: 267,
    country: "Cameroon",
    timestate: "",
    timecity: "Yaoundé",
    timediff: 60,
    timeZoneTimeAbbreviation: "AfricaWAT",
    iana_timezone: "Africa/Lagos",
  },
  {
    timerect: 1113,
    timereftime: 133,
    country: "Portugal",
    timestate: "",
    timecity: "Lisbon",
    timediff: 0,
    timeZoneTimeAbbreviation: "EuropeWEST",
    iana_timezone: "Europe/Lisbon",
  },
  {
    timerect: 1114,
    timereftime: 55,
    country: "Canada",
    timestate: "Alberta",
    timecity: "Calgary",
    timediff: -420,
    timeZoneTimeAbbreviation: "AmericaMST",
    iana_timezone: "America/Edmonton",
  },
  {
    timerect: 1115,
    timereftime: 320,
    country: "Portugal",
    timestate: "",
    timecity: "Porto",
    timediff: 0,
    timeZoneTimeAbbreviation: "EuropeWET",
    iana_timezone: "Europe/Lisbon",
  },
  {
    timerect: 1116,
    timereftime: 80,
    country: "Canada",
    timestate: "Alberta",
    timecity: "Edmonton",
    timediff: -420,
    timeZoneTimeAbbreviation: "AmericaMDT",
    iana_timezone: "America/Edmonton",
  },
  {
    timerect: 1117,
    timereftime: 226,
    country: "Puerto Rico",
    timestate: "",
    timecity: "San Juan",
    timediff: -240,
    timeZoneTimeAbbreviation: "AmericaAST",
    iana_timezone: "America/Puerto_Rico",
  },
  {
    timerect: 1118,
    timereftime: 256,
    country: "Canada",
    timestate: "British Columbia",
    timecity: "Vancouver",
    timediff: -480,
    timeZoneTimeAbbreviation: "AmericaPDT",
    iana_timezone: "America/Vancouver",
  },
  {
    timerect: 1119,
    timereftime: 8,
    country: "Qatar",
    timestate: "",
    timecity: "Doha",
    timediff: 180,
    timeZoneTimeAbbreviation: "AsiaAST",
    iana_timezone: "Asia/Qatar",
  },
  {
    timerect: 1120,
    timereftime: 265,
    country: "Canada",
    timestate: "Manitoba",
    timecity: "Winnipeg",
    timediff: -360,
    timeZoneTimeAbbreviation: "AmericaCDT",
    iana_timezone: "America/Winnipeg",
  },
  {
    timerect: 1121,
    timereftime: 216,
    country: "Reunion (French)",
    timestate: "",
    timecity: "SaintDenis",
    timediff: 240,
    timeZoneTimeAbbreviation: "EuropeRET",
    iana_timezone: "Indian/Reunion",
  },
  {
    timerect: 1122,
    timereftime: 749,
    country: "Canada",
    timestate: "New Brunswick",
    timecity: "Saint John",
    timediff: -240,
    timeZoneTimeAbbreviation: "AmericaAST",
    iana_timezone: "America/Moncton",
  },
  {
    timerect: 1123,
    timereftime: 49,
    country: "Romania",
    timestate: "",
    timecity: "Bucharest",
    timediff: 120,
    timeZoneTimeAbbreviation: "EuropeEEST",
    iana_timezone: "Europe/Bucharest",
  },
  {
    timerect: 1124,
    timereftime: 175,
    country: "Canada",
    timestate: "Newfoundland",
    timecity: "St. John's",
    timediff: -210,
    timeZoneTimeAbbreviation: "AmericaNST",
    iana_timezone: "America/St_Johns",
  },
  {
    timerect: 1125,
    timereftime: 17,
    country: "Russia",
    timestate: "",
    timecity: "Anadyr",
    timediff: 720,
    timeZoneTimeAbbreviation: "AsiaANADT",
    iana_timezone: "Asia/Anadyr",
  },
  {
    timerect: 1126,
    timereftime: 10,
    country: "Canada",
    timestate: "Northwest Territories",
    timecity: "Aklavik",
    timediff: -420,
    timeZoneTimeAbbreviation: "AmericaMST",
    iana_timezone: "America/Inuvik",
  },
  {
    timerect: 1127,
    timereftime: 373,
    country: "Russia",
    timestate: "",
    timecity: "Chelyabinsk",
    timediff: 360,
    timeZoneTimeAbbreviation: "AsiaYEKT",
    iana_timezone: "Asia/Yekaterinburg",
  },
  {
    timerect: 1128,
    timereftime: 678,
    country: "Canada",
    timestate: "Northwest Territories",
    timecity: "Yellowknife",
    timediff: -420,
    timeZoneTimeAbbreviation: "AmericaMDT",
    iana_timezone: "America/Yellowknife",
  },
  {
    timerect: 1129,
    timereftime: 528,
    country: "Russia",
    timestate: "",
    timecity: "Kaliningrad",
    timediff: 180,
    timeZoneTimeAbbreviation: "EuropeEET",
    iana_timezone: "Europe/Kaliningrad",
  },
  {
    timerect: 1130,
    timereftime: 286,
    country: "Canada",
    timestate: "Nova Scotia",
    timecity: "Halifax",
    timediff: -240,
    timeZoneTimeAbbreviation: "AmericaADT",
    iana_timezone: "America/Halifax",
  },
  {
    timerect: 1131,
    timereftime: 114,
    country: "Russia",
    timestate: "",
    timecity: "Kamchatka",
    timediff: 720,
    timeZoneTimeAbbreviation: "AsiaPETT",
    iana_timezone: "Asia/Kamchatka",
  },
  {
    timerect: 1132,
    timereftime: 677,
    country: "Canada",
    timestate: "Nunavut Territory",
    timecity: "Iqaluit",
    timediff: -300,
    timeZoneTimeAbbreviation: "AmericaEDT",
    iana_timezone: "America/Iqaluit",
  },
  {
    timerect: 1133,
    timereftime: 354,
    country: "Russia",
    timestate: "",
    timecity: "Kazan",
    timediff: 240,
    timeZoneTimeAbbreviation: "AsiaMSK",
    iana_timezone: "Europe/Moscow",
  },
  {
    timerect: 1134,
    timereftime: 188,
    country: "Canada",
    timestate: "Ontario",
    timecity: "Ottawa",
    timediff: -300,
    timeZoneTimeAbbreviation: "AmericaEST",
    iana_timezone: "America/Toronto",
  },
  {
    timerect: 1135,
    timereftime: 372,
    country: "Russia",
    timestate: "",
    timecity: "Krasnoyarsk",
    timediff: 480,
    timeZoneTimeAbbreviation: "AsiaKRAT",
    iana_timezone: "Asia/Krasnoyarsk",
  },
  {
    timerect: 1136,
    timereftime: 250,
    country: "Canada",
    timestate: "Ontario",
    timecity: "Toronto",
    timediff: -300,
    timeZoneTimeAbbreviation: "AmericaEDT",
    iana_timezone: "America/Toronto",
  },
  {
    timerect: 1137,
    timereftime: 166,
    country: "Russia",
    timestate: "",
    timecity: "Moscow",
    timediff: 240,
    timeZoneTimeAbbreviation: "EuropeMSK",
    iana_timezone: "Europe/Moscow",
  },
  {
    timerect: 1138,
    timereftime: 753,
    country: "Canada",
    timestate: "Pr.Edward I",
    timecity: "Charlottetown",
    timediff: -180,
    timeZoneTimeAbbreviation: "AmericaAST",
    iana_timezone: "America/Moncton",
  },
  {
    timerect: 1139,
    timereftime: 167,
    country: "Russia",
    timestate: "",
    timecity: "Murmansk",
    timediff: 240,
    timeZoneTimeAbbreviation: "AsiaMSK",
    iana_timezone: "Europe/Moscow",
  },
  {
    timerect: 1140,
    timereftime: 165,
    country: "Canada",
    timestate: "Quebec",
    timecity: "Montreal",
    timediff: -300,
    timeZoneTimeAbbreviation: "AmericaEST",
    iana_timezone: "America/Montreal",
  },
  {
    timerect: 1141,
    timereftime: 353,
    country: "Russia",
    timestate: "",
    timecity: "Novgorod",
    timediff: 240,
    timeZoneTimeAbbreviation: "AsiaMSK",
    iana_timezone: "Europe/Moscow",
  },
  {
    timerect: 1142,
    timereftime: 189,
    country: "Canada",
    timestate: "Quebec",
    timecity: "Québec",
    timediff: -300,
    timeZoneTimeAbbreviation: "AmericaEST",
    iana_timezone: "America/Montreal",
  },
  {
    timerect: 1143,
    timereftime: 375,
    country: "Russia",
    timestate: "",
    timecity: "Novosibirsk",
    timediff: 420,
    timeZoneTimeAbbreviation: "AsiaNOVT",
    iana_timezone: "Asia/Novosibirsk",
  },
  {
    timerect: 1144,
    timereftime: 210,
    country: "Canada",
    timestate: "Saskatchewan",
    timecity: "Regina",
    timediff: -360,
    timeZoneTimeAbbreviation: "AmericaCST",
    iana_timezone: "America/Regina",
  },
  {
    timerect: 1145,
    timereftime: 374,
    country: "Russia",
    timestate: "",
    timecity: "Omsk",
    timediff: 420,
    timeZoneTimeAbbreviation: "AsiaOMST",
    iana_timezone: "Asia/Omsk",
  },
  {
    timerect: 1146,
    timereftime: 679,
    country: "Canada",
    timestate: "Yukon",
    timecity: "Whitehorse",
    timediff: -480,
    timeZoneTimeAbbreviation: "AmericaMST",
    iana_timezone: "America/Whitehorse",
  },
  {
    timerect: 1147,
    timereftime: 357,
    country: "Russia",
    timestate: "",
    timecity: "Perm",
    timediff: 360,
    timeZoneTimeAbbreviation: "AsiaMSK",
    iana_timezone: "Asia/Yekaterinburg",
  },
  {
    timerect: 1148,
    timereftime: 685,
    country: "Cape Verde",
    timestate: "",
    timecity: "Praia",
    timediff: -60,
    timeZoneTimeAbbreviation: "AtlanticCVT",
    iana_timezone: "Atlantic/Cape_Verde",
  },
  {
    timerect: 1149,
    timereftime: 352,
    country: "Russia",
    timestate: "",
    timecity: "SaintPeterburg",
    timediff: 240,
    timeZoneTimeAbbreviation: "AsiaMSK",
    iana_timezone: "Europe/Moscow",
  },
  {
    timerect: 1150,
    timereftime: 694,
    country: "Central African Republic",
    timestate: "",
    timecity: "Bangui",
    timediff: 60,
    timeZoneTimeAbbreviation: "AfricaWAT",
    iana_timezone: "Africa/Bangui",
  },
  {
    timerect: 1151,
    timereftime: 355,
    country: "Russia",
    timestate: "",
    timecity: "Samara",
    timediff: 240,
    timeZoneTimeAbbreviation: "EuropeSAMT",
    iana_timezone: "Europe/Samara",
  },
  {
    timerect: 1152,
    timereftime: 174,
    country: "Chad",
    timestate: "",
    timecity: "Ndjamena",
    timediff: 60,
    timeZoneTimeAbbreviation: "AfricaWAT",
    iana_timezone: "Africa/Ndjamena",
  },
  {
    timerect: 1153,
    timereftime: 356,
    country: "Russia",
    timestate: "",
    timecity: "Ufa",
    timediff: 360,
    timeZoneTimeAbbreviation: "AsiaMSK",
    iana_timezone: "Asia/Yekaterinburg",
  },
  {
    timerect: 1154,
    timereftime: 914,
    country: "Chile",
    timestate: "",
    timecity: "Easter Island",
    timediff: -300,
    timeZoneTimeAbbreviation: "AmericaEAST",
    iana_timezone: "Pacific/Easter",
  },
  {
    timerect: 1155,
    timereftime: 261,
    country: "Russia",
    timestate: "",
    timecity: "Vladivostok",
    timediff: 660,
    timeZoneTimeAbbreviation: "AsiaVLAT",
    iana_timezone: "Asia/Vladivostok",
  },
  {
    timerect: 1156,
    timereftime: 232,
    country: "Chile",
    timestate: "",
    timecity: "Santiago",
    timediff: -180,
    timeZoneTimeAbbreviation: "AmericaCLST",
    iana_timezone: "America/Santiago",
  },
  {
    timerect: 1157,
    timereftime: 358,
    country: "Russia",
    timestate: "",
    timecity: "Yekaterinburg",
    timediff: 360,
    timeZoneTimeAbbreviation: "AsiaYEKT",
    iana_timezone: "Asia/Yekaterinburg",
  },
  {
    timerect: 1158,
    timereftime: 427,
    country: "China",
    timestate: "",
    timecity: "Anshan",
    timediff: 480,
    timeZoneTimeAbbreviation: "AsiaCST",
    iana_timezone: "Asia/Shanghai",
  },
  {
    timerect: 1159,
    timereftime: 119,
    country: "Rwanda",
    timestate: "",
    timecity: "Kigali",
    timediff: 120,
    timeZoneTimeAbbreviation: "AfricaCAT",
    iana_timezone: "Africa/Kigali",
  },
  {
    timerect: 1160,
    timereftime: 440,
    country: "China",
    timestate: "",
    timecity: "Baotou",
    timediff: 480,
    timeZoneTimeAbbreviation: "AsiaCST",
    iana_timezone: "Asia/Shanghai",
  },
  {
    timerect: 1161,
    timereftime: 728,
    country: "Saint Kitts and Nevis",
    timestate: "",
    timecity: "Basseterre",
    timediff: -240,
    timeZoneTimeAbbreviation: "AtlanticAST",
    iana_timezone: "America/St_Kitts",
  },
  {
    timerect: 1162,
    timereftime: 33,
    country: "China",
    timestate: "",
    timecity: "Beijing",
    timediff: 480,
    timeZoneTimeAbbreviation: "AsiaCST",
    iana_timezone: "Asia/Shanghai",
  },
  {
    timerect: 1163,
    timereftime: 729,
    country: "Saint Lucia",
    timestate: "",
    timecity: "Castries",
    timediff: -240,
    timeZoneTimeAbbreviation: "AtlanticAST",
    iana_timezone: "America/St_Lucia",
  },
  {
    timerect: 1164,
    timereftime: 459,
    country: "China",
    timestate: "",
    timecity: "Canton",
    timediff: 480,
    timeZoneTimeAbbreviation: "AsiaCST",
    iana_timezone: "Asia/Shanghai",
  },
  {
    timerect: 1165,
    timereftime: 731,
    country: "Saint Vincent and Grenadines",
    timestate: "",
    timecity: "Kingstown",
    timediff: -240,
    timeZoneTimeAbbreviation: "AtlanticAST",
    iana_timezone: "America/St_Vincent",
  },
  {
    timerect: 1166,
    timereftime: 464,
    country: "China",
    timestate: "",
    timecity: "Changchun",
    timediff: 480,
    timeZoneTimeAbbreviation: "AsiaCST",
    iana_timezone: "Asia/Shanghai",
  },
  {
    timerect: 1167,
    timereftime: 282,
    country: "Samoa",
    timestate: "",
    timecity: "Apia",
    timediff: 840,
    timeZoneTimeAbbreviation: "PacificWST",
    iana_timezone: "Pacific/Apia",
  },
  {
    timerect: 1168,
    timereftime: 465,
    country: "China",
    timestate: "",
    timecity: "Changsha",
    timediff: 480,
    timeZoneTimeAbbreviation: "AsiaCST",
    iana_timezone: "Asia/Shanghai",
  },
  {
    timerect: 1169,
    timereftime: 732,
    country: "San Marino",
    timestate: "",
    timecity: "San Marino",
    timediff: 60,
    timeZoneTimeAbbreviation: "EuropeCET",
    iana_timezone: "Europe/Rome",
  },
  {
    timerect: 1170,
    timereftime: 466,
    country: "China",
    timestate: "",
    timecity: "Chengdu",
    timediff: 480,
    timeZoneTimeAbbreviation: "AsiaCST",
    iana_timezone: "Asia/Shanghai",
  },
  {
    timerect: 1171,
    timereftime: 733,
    country: "Sao Tome and Principe",
    timestate: "",
    timecity: "São Tomé",
    timediff: 0,
    timeZoneTimeAbbreviation: "AfricaGMT",
    iana_timezone: "Africa/Sao_Tome",
  },
  {
    timerect: 1172,
    timereftime: 470,
    country: "China",
    timestate: "",
    timecity: "Chongqing",
    timediff: 480,
    timeZoneTimeAbbreviation: "AsiaCST",
    iana_timezone: "Asia/Shanghai",
  },
  {
    timerect: 1173,
    timereftime: 748,
    country: "Saudi Arabia",
    timestate: "",
    timecity: "Jeddah",
    timediff: 180,
    timeZoneTimeAbbreviation: "AsiaAST",
    iana_timezone: "Asia/Riyadh",
  },
  {
    timerect: 1174,
    timereftime: 490,
    country: "China",
    timestate: "",
    timecity: "Foochow",
    timediff: 480,
    timeZoneTimeAbbreviation: "AsiaCST",
    iana_timezone: "Asia/Shanghai",
  },
  {
    timerect: 1175,
    timereftime: 151,
    country: "Saudi Arabia",
    timestate: "",
    timecity: "Makkah",
    timediff: 180,
    timeZoneTimeAbbreviation: "AsiaAST",
    iana_timezone: "Asia/Riyadh",
  },
  {
    timerect: 1176,
    timereftime: 493,
    country: "China",
    timestate: "",
    timecity: "Fushun",
    timediff: 480,
    timeZoneTimeAbbreviation: "AsiaCST",
    iana_timezone: "Asia/Shanghai",
  },
  {
    timerect: 1177,
    timereftime: 214,
    country: "Saudi Arabia",
    timestate: "",
    timecity: "Riyadh",
    timediff: 180,
    timeZoneTimeAbbreviation: "AsiaAST",
    iana_timezone: "Asia/Riyadh",
  },
  {
    timerect: 1178,
    timereftime: 499,
    country: "China",
    timestate: "",
    timecity: "Guiyang",
    timediff: 480,
    timeZoneTimeAbbreviation: "AsiaCST",
    iana_timezone: "Asia/Shanghai",
  },
  {
    timerect: 1179,
    timereftime: 74,
    country: "Senegal",
    timestate: "",
    timecity: "Dakar",
    timediff: 0,
    timeZoneTimeAbbreviation: "AfricaGMT",
    iana_timezone: "Africa/Dakar",
  },
  {
    timerect: 1180,
    timereftime: 501,
    country: "China",
    timestate: "",
    timecity: "Hangzhou",
    timediff: 480,
    timeZoneTimeAbbreviation: "AsiaCST",
    iana_timezone: "Asia/Shanghai",
  },
  {
    timerect: 1181,
    timereftime: 743,
    country: "Serbia and Montenegro",
    timestate: "Kosovo",
    timecity: "Pristina",
    timediff: 60,
    timeZoneTimeAbbreviation: "EuropeCET",
    iana_timezone: "Europe/Belgrade",
  },
  {
    timerect: 1182,
    timereftime: 502,
    country: "China",
    timestate: "",
    timecity: "Harbin",
    timediff: 480,
    timeZoneTimeAbbreviation: "AsiaCST",
    iana_timezone: "Asia/Shanghai",
  },
  {
    timerect: 1183,
    timereftime: 744,
    country: "Serbia and Montenegro",
    timestate: "Montenegro",
    timecity: "Podgoriza",
    timediff: 60,
    timeZoneTimeAbbreviation: "EuropeCET",
    iana_timezone: "Europe/Podgorica",
  },
  {
    timerect: 1184,
    timereftime: 102,
    country: "China",
    timestate: "",
    timecity: "Hong Kong",
    timediff: 480,
    timeZoneTimeAbbreviation: "AsiaCST",
    iana_timezone: "Asia/Hong_Kong",
  },
  {
    timerect: 1185,
    timereftime: 35,
    country: "Serbia and Montenegro",
    timestate: "Serbia",
    timecity: "Belgrade",
    timediff: 60,
    timeZoneTimeAbbreviation: "EuropeCEST",
    iana_timezone: "Europe/Belgrade",
  },
  {
    timerect: 1186,
    timereftime: 519,
    country: "China",
    timestate: "",
    timecity: "Jilin",
    timediff: 480,
    timeZoneTimeAbbreviation: "AsiaCST",
    iana_timezone: "Asia/Shanghai",
  },
  {
    timerect: 1187,
    timereftime: 734,
    country: "Seychelles",
    timestate: "",
    timecity: "Victoria",
    timediff: 240,
    timeZoneTimeAbbreviation: "AfricaHKT",
    iana_timezone: "Indian/Mahe",
  },
  {
    timerect: 1188,
    timereftime: 520,
    country: "China",
    timestate: "",
    timecity: "Jinan",
    timediff: 480,
    timeZoneTimeAbbreviation: "AsiaCST",
    iana_timezone: "Asia/Shanghai",
  },
  {
    timerect: 1189,
    timereftime: 85,
    country: "Sierra Leone",
    timestate: "",
    timecity: "Freetown",
    timediff: 0,
    timeZoneTimeAbbreviation: "AfricaGMT",
    iana_timezone: "Africa/Freetown",
  },
  {
    timerect: 1190,
    timereftime: 521,
    country: "China",
    timestate: "",
    timecity: "Jinzhou",
    timediff: 480,
    timeZoneTimeAbbreviation: "AsiaCST",
    iana_timezone: "Asia/Shanghai",
  },
  {
    timerect: 1191,
    timereftime: 236,
    country: "Singapore",
    timestate: "",
    timecity: "Singapore",
    timediff: 480,
    timeZoneTimeAbbreviation: "AsiaCST",
    iana_timezone: "Asia/Singapore",
  },
  {
    timerect: 1192,
    timereftime: 533,
    country: "China",
    timestate: "",
    timecity: "Kowloon",
    timediff: 480,
    timeZoneTimeAbbreviation: "AsiaHKT",
    iana_timezone: "Asia/Hong_Kong",
  },
  {
    timerect: 1193,
    timereftime: 735,
    country: "Slovak Republic",
    timestate: "",
    timecity: "Bratislava",
    timediff: 60,
    timeZoneTimeAbbreviation: "EuropeCEST",
    iana_timezone: "Europe/Bratislava",
  },
  {
    timerect: 1194,
    timereftime: 537,
    country: "China",
    timestate: "",
    timecity: "Kunming",
    timediff: 480,
    timeZoneTimeAbbreviation: "AsiaCST",
    iana_timezone: "Asia/Shanghai",
  },
  {
    timerect: 1195,
    timereftime: 736,
    country: "Slovenia",
    timestate: "",
    timecity: "Ljubljana",
    timediff: 60,
    timeZoneTimeAbbreviation: "EuropeCEST",
    iana_timezone: "Europe/Ljubljana",
  },
  {
    timerect: 1196,
    timereftime: 542,
    country: "China",
    timestate: "",
    timecity: "Lanchow",
    timediff: 480,
    timeZoneTimeAbbreviation: "AsiaCST",
    iana_timezone: "Asia/Shanghai",
  },
  {
    timerect: 1197,
    timereftime: 273,
    country: "Solomon Islands",
    timestate: "",
    timecity: "Honiara",
    timediff: 660,
    timeZoneTimeAbbreviation: "AustraliaSBT",
    iana_timezone: "Pacific/Guadalcanal",
  },
  {
    timerect: 1198,
    timereftime: 918,
    country: "China",
    timestate: "",
    timecity: "Lhasa",
    timediff: 480,
    timeZoneTimeAbbreviation: "AsiaTT",
    iana_timezone: "Asia/Shanghai",
  },
  {
    timerect: 1199,
    timereftime: 160,
    country: "Somalia",
    timestate: "",
    timecity: "Mogadishu",
    timediff: 180,
    timeZoneTimeAbbreviation: "AfricaEAT",
    iana_timezone: "Africa/Mogadishu",
  },
  {
    timerect: 1200,
    timereftime: 546,
    country: "China",
    timestate: "",
    timecity: "Luoyang",
    timediff: 480,
    timeZoneTimeAbbreviation: "AsiaCST",
    iana_timezone: "Asia/Shanghai",
  },
  {
    timerect: 1201,
    timereftime: 56,
    country: "South Africa",
    timestate: "",
    timecity: "Cape Town",
    timediff: 120,
    timeZoneTimeAbbreviation: "AfricaSAST",
    iana_timezone: "Africa/Johannesburg",
  },
  {
    timerect: 1202,
    timereftime: 549,
    country: "China",
    timestate: "",
    timecity: "Lüda",
    timediff: 480,
    timeZoneTimeAbbreviation: "AsiaCST",
    iana_timezone: "Asia/Shanghai",
  },
  {
    timerect: 1203,
    timereftime: 111,
    country: "South Africa",
    timestate: "",
    timecity: "Johannesburg",
    timediff: 120,
    timeZoneTimeAbbreviation: "AfricaSAST",
    iana_timezone: "Africa/Johannesburg",
  },
  {
    timerect: 1204,
    timereftime: 754,
    country: "China",
    timestate: "",
    timecity: "Macau",
    timediff: 480,
    timeZoneTimeAbbreviation: "AsiaCST",
    iana_timezone: "Asia/Macau",
  },
  {
    timerect: 1205,
    timereftime: 269,
    country: "South Africa",
    timestate: "",
    timecity: "Pretoria",
    timediff: 120,
    timeZoneTimeAbbreviation: "AfricaSAST",
    iana_timezone: "Africa/Johannesburg",
  },
  {
    timerect: 1206,
    timereftime: 566,
    country: "China",
    timestate: "",
    timecity: "Nanchang",
    timediff: 480,
    timeZoneTimeAbbreviation: "AsiaCST",
    iana_timezone: "Asia/Shanghai",
  },
  {
    timerect: 1207,
    timereftime: 509,
    country: "South Korea",
    timestate: "",
    timecity: "Incheon",
    timediff: 540,
    timeZoneTimeAbbreviation: "AsiaKST",
    iana_timezone: "Asia/Seoul",
  },
  {
    timerect: 1208,
    timereftime: 597,
    country: "China",
    timestate: "",
    timecity: "Qiqihar",
    timediff: 480,
    timeZoneTimeAbbreviation: "AsiaCST",
    iana_timezone: "Asia/Shanghai",
  },
  {
    timerect: 1209,
    timereftime: 594,
    country: "South Korea",
    timestate: "",
    timecity: "Pusan",
    timediff: 540,
    timeZoneTimeAbbreviation: "AsiaKST",
    iana_timezone: "Asia/Seoul",
  },
  {
    timerect: 1210,
    timereftime: 237,
    country: "China",
    timestate: "",
    timecity: "Shanghai",
    timediff: 480,
    timeZoneTimeAbbreviation: "AsiaCST",
    iana_timezone: "Asia/Shanghai",
  },
  {
    timerect: 1211,
    timereftime: 235,
    country: "South Korea",
    timestate: "",
    timecity: "Seoul",
    timediff: 540,
    timeZoneTimeAbbreviation: "AsiaKST",
    iana_timezone: "Asia/Seoul",
  },
  {
    timerect: 1212,
    timereftime: 625,
    country: "China",
    timestate: "",
    timecity: "Shijiazhuang",
    timediff: 480,
    timeZoneTimeAbbreviation: "AsiaCST",
    iana_timezone: "Asia/Shanghai",
  },
  {
    timerect: 1213,
    timereftime: 636,
    country: "South Korea",
    timestate: "",
    timecity: "Taegu",
    timediff: 540,
    timeZoneTimeAbbreviation: "AsiaKST",
    iana_timezone: "Asia/Seoul",
  },
  {
    timerect: 1214,
    timereftime: 626,
    country: "China",
    timestate: "",
    timecity: "Sian",
    timediff: 480,
    timeZoneTimeAbbreviation: "AsiaCST",
    iana_timezone: "Asia/Shanghai",
  },
  {
    timerect: 1215,
    timereftime: 31,
    country: "Spain",
    timestate: "",
    timecity: "Barcelona",
    timediff: 60,
    timeZoneTimeAbbreviation: "EuropeCET",
    iana_timezone: "Europe/Madrid",
  },
  {
    timerect: 1216,
    timereftime: 637,
    country: "China",
    timestate: "",
    timecity: "Taiyuan",
    timediff: 480,
    timeZoneTimeAbbreviation: "AsiaCST",
    iana_timezone: "Asia/Shanghai",
  },
  {
    timerect: 1217,
    timereftime: 322,
    country: "Spain",
    timestate: "",
    timecity: "Córdoba",
    timediff: 60,
    timeZoneTimeAbbreviation: "EuropeART",
    iana_timezone: "Europe/Madrid",
  },
  {
    timerect: 1218,
    timereftime: 640,
    country: "China",
    timestate: "",
    timecity: "Tangshan",
    timediff: 480,
    timeZoneTimeAbbreviation: "AsiaCST",
    iana_timezone: "Asia/Shanghai",
  },
  {
    timerect: 1219,
    timereftime: 681,
    country: "Spain",
    timestate: "",
    timecity: "La Coruña",
    timediff: 60,
    timeZoneTimeAbbreviation: "EuropeCET",
    iana_timezone: "Europe/Madrid",
  },
  {
    timerect: 1220,
    timereftime: 646,
    country: "China",
    timestate: "",
    timecity: "Tientsin",
    timediff: 480,
    timeZoneTimeAbbreviation: "AsiaCST",
    iana_timezone: "Asia/Shanghai",
  },
  {
    timerect: 1221,
    timereftime: 684,
    country: "Spain",
    timestate: "Canary Islands",
    timecity: "Las Palmas",
    timediff: 0,
    timeZoneTimeAbbreviation: "EuropeWET",
    iana_timezone: "Atlantic/Canary",
  },
  {
    timerect: 1222,
    timereftime: 649,
    country: "China",
    timestate: "",
    timecity: "Tsingtao",
    timediff: 480,
    timeZoneTimeAbbreviation: "AsiaCST",
    iana_timezone: "Asia/Shanghai",
  },
  {
    timerect: 1223,
    timereftime: 141,
    country: "Spain",
    timestate: "",
    timecity: "Madrid",
    timediff: 60,
    timeZoneTimeAbbreviation: "EuropeCEST",
    iana_timezone: "Europe/Madrid",
  },
  {
    timerect: 1224,
    timereftime: 665,
    country: "China",
    timestate: "",
    timecity: "Wuhan",
    timediff: 480,
    timeZoneTimeAbbreviation: "AsiaCST",
    iana_timezone: "Asia/Shanghai",
  },
  {
    timerect: 1225,
    timereftime: 191,
    country: "Spain",
    timestate: "Mallorca",
    timecity: "Palma",
    timediff: 60,
    timeZoneTimeAbbreviation: "EuropeCET",
    iana_timezone: "Europe/Madrid",
  },
  {
    timerect: 1226,
    timereftime: 668,
    country: "China",
    timestate: "",
    timecity: "Zhengzhou",
    timediff: 480,
    timeZoneTimeAbbreviation: "AsiaCST",
    iana_timezone: "Asia/Shanghai",
  },
  {
    timerect: 1227,
    timereftime: 389,
    country: "Sri Lanka",
    timestate: "",
    timecity: "Colombo",
    timediff: 330,
    timeZoneTimeAbbreviation: "AsiaIST",
    iana_timezone: "Asia/Colombo",
  },
  {
    timerect: 1228,
    timereftime: 669,
    country: "China",
    timestate: "",
    timecity: "Zibo",
    timediff: 480,
    timeZoneTimeAbbreviation: "AsiaCST",
    iana_timezone: "Asia/Shanghai",
  },
  {
    timerect: 1229,
    timereftime: 118,
    country: "Sudan",
    timestate: "",
    timecity: "Khartoum",
    timediff: 180,
    timeZoneTimeAbbreviation: "AfricaCAT",
    iana_timezone: "Africa/Khartoum",
  },
  {
    timerect: 1230,
    timereftime: 41,
    country: "Colombia",
    timestate: "",
    timecity: "Bogota",
    timediff: -300,
    timeZoneTimeAbbreviation: "AmericaCOT",
    iana_timezone: "America/Bogota",
  },
  {
    timerect: 1231,
    timereftime: 194,
    country: "Suriname",
    timestate: "",
    timecity: "Paramaribo",
    timediff: -180,
    timeZoneTimeAbbreviation: "AmericaSRT",
    iana_timezone: "America/Paramaribo",
  },
  {
    timerect: 1232,
    timereftime: 453,
    country: "Colombia",
    timestate: "",
    timecity: "Cali",
    timediff: -300,
    timeZoneTimeAbbreviation: "AmericaCOT",
    iana_timezone: "America/Bogota",
  },
  {
    timerect: 1233,
    timereftime: 149,
    country: "Swaziland",
    timestate: "",
    timecity: "Mbabane",
    timediff: 120,
    timeZoneTimeAbbreviation: "AfricaSAST",
    iana_timezone: "Africa/Mbabane",
  },
  {
    timerect: 1234,
    timereftime: 150,
    country: "Colombia",
    timestate: "",
    timecity: "Medellin",
    timediff: -300,
    timeZoneTimeAbbreviation: "AmericaCOT",
    iana_timezone: "America/Bogota",
  },
  {
    timerect: 1235,
    timereftime: 239,
    country: "Sweden",
    timestate: "",
    timecity: "Stockholm",
    timediff: 60,
    timeZoneTimeAbbreviation: "EuropeCEST",
    iana_timezone: "Europe/Stockholm",
  },
  {
    timerect: 1236,
    timereftime: 696,
    country: "Comoros",
    timestate: "",
    timecity: "Moroni",
    timediff: 180,
    timeZoneTimeAbbreviation: "AfricaEAT",
    iana_timezone: "Indian/Comoro",
  },
  {
    timerect: 1237,
    timereftime: 270,
    country: "Switzerland",
    timestate: "",
    timecity: "Bern",
    timediff: 60,
    timeZoneTimeAbbreviation: "EuropeCET",
    iana_timezone: "Europe/Zurich",
  },
  {
    timerect: 1238,
    timereftime: 926,
    country: "Congo",
    timestate: "",
    timecity: "Brazzaville",
    timediff: 60,
    timeZoneTimeAbbreviation: "AfricaWAT",
    iana_timezone: "Africa/Brazzaville",
  },
  {
    timerect: 1239,
    timereftime: 87,
    country: "Switzerland",
    timestate: "",
    timecity: "Geneva",
    timediff: 60,
    timeZoneTimeAbbreviation: "EuropeCET",
    iana_timezone: "Europe/Zurich",
  },
  {
    timerect: 1240,
    timereftime: 121,
    country: "Congo Dem.Rep.",
    timestate: "",
    timecity: "Kinshasa",
    timediff: 60,
    timeZoneTimeAbbreviation: "AfricaWAT",
    iana_timezone: "Africa/Kinshasa",
  },
  {
    timerect: 1241,
    timereftime: 945,
    country: "Switzerland",
    timestate: "",
    timecity: "Lausanne",
    timediff: 60,
    timeZoneTimeAbbreviation: "EuropeCET",
    iana_timezone: "Europe/Zurich",
  },
  {
    timerect: 1242,
    timereftime: 139,
    country: "Congo Dem.Rep.",
    timestate: "",
    timecity: "Lubumbashi",
    timediff: 120,
    timeZoneTimeAbbreviation: "AfricaCAT",
    iana_timezone: "Africa/Lubumbashi",
  },
  {
    timerect: 1243,
    timereftime: 268,
    country: "Switzerland",
    timestate: "",
    timecity: "Zürich",
    timediff: 60,
    timeZoneTimeAbbreviation: "EuropeCET",
    iana_timezone: "Europe/Zurich",
  },
  {
    timerect: 1244,
    timereftime: 279,
    country: "Cook Islands",
    timestate: "",
    timecity: "Rarotonga",
    timediff: -600,
    timeZoneTimeAbbreviation: "PacificCKT",
    iana_timezone: "Pacific/Rarotonga",
  },
  {
    timerect: 1245,
    timereftime: 487,
    country: "Syria",
    timestate: "",
    timecity: "Damascus",
    timediff: 120,
    timeZoneTimeAbbreviation: "AsiaEEST",
    iana_timezone: "Asia/Damascus",
  },
  {
    timerect: 1246,
    timereftime: 225,
    country: "Costa Rica",
    timestate: "",
    timecity: "San Jose",
    timediff: -360,
    timeZoneTimeAbbreviation: "AmericaCST",
    iana_timezone: "America/Costa_Rica",
  },
  {
    timerect: 1247,
    timereftime: 1067,
    country: "Taiwan",
    timestate: "",
    timecity: "Kaohsiung",
    timediff: 480,
    timeZoneTimeAbbreviation: "AsiaCST",
    iana_timezone: "Asia/Taipei",
  },
  {
    timerect: 1248,
    timereftime: 1,
    country: "Cote d'Ivoire",
    timestate: "",
    timecity: "Abidjan",
    timediff: 0,
    timeZoneTimeAbbreviation: "AfricaGMT",
    iana_timezone: "Africa/Abidjan",
  },
  {
    timerect: 1249,
    timereftime: 241,
    country: "Taiwan",
    timestate: "",
    timecity: "Taipei",
    timediff: 480,
    timeZoneTimeAbbreviation: "AsiaCST",
    iana_timezone: "Asia/Taipei",
  },
  {
    timerect: 1250,
    timereftime: 935,
    country: "Cote d'Ivoire",
    timestate: "",
    timecity: "Yamoussoukro",
    timediff: 0,
    timeZoneTimeAbbreviation: "AfricaGMT",
    iana_timezone: "Africa/Abidjan",
  },
  {
    timerect: 1251,
    timereftime: 385,
    country: "Tajikistan",
    timestate: "",
    timecity: "Dushanbe",
    timediff: 300,
    timeZoneTimeAbbreviation: "AsiaTJT",
    iana_timezone: "Asia/Dushanbe",
  },
  {
    timerect: 1252,
    timereftime: 281,
    country: "Croatia",
    timestate: "",
    timecity: "Zagreb",
    timediff: 60,
    timeZoneTimeAbbreviation: "EuropeCEST",
    iana_timezone: "Europe/Zagreb",
  },
  {
    timerect: 1253,
    timereftime: 71,
    country: "Tanzania",
    timestate: "",
    timecity: "Dar es Salaam",
    timediff: 180,
    timeZoneTimeAbbreviation: "AfricaEAT",
    iana_timezone: "Africa/Dar_es_Salaam",
  },
  {
    timerect: 1254,
    timereftime: 99,
    country: "Cuba",
    timestate: "",
    timecity: "Havana",
    timediff: -300,
    timeZoneTimeAbbreviation: "AmericaCDT",
    iana_timezone: "America/Havana",
  },
  {
    timerect: 1255,
    timereftime: 1030,
    country: "Tanzania",
    timestate: "",
    timecity: "Dodoma",
    timediff: 180,
    timeZoneTimeAbbreviation: "AfricaEAT",
    iana_timezone: "Africa/Dar_es_Salaam",
  },
  {
    timerect: 1256,
    timereftime: 680,
    country: "Cyprus",
    timestate: "",
    timecity: "Nicosia",
    timediff: 120,
    timeZoneTimeAbbreviation: "AsiaEEST",
    iana_timezone: "Asia/Nicosia",
  },
  {
    timerect: 1257,
    timereftime: 28,
    country: "Thailand",
    timestate: "",
    timecity: "Bangkok",
    timediff: 420,
    timeZoneTimeAbbreviation: "AsiaICT",
    iana_timezone: "Asia/Bangkok",
  },
  {
    timerect: 1258,
    timereftime: 204,
    country: "Czech Republic",
    timestate: "",
    timecity: "Prague",
    timediff: 60,
    timeZoneTimeAbbreviation: "EuropeCEST",
    iana_timezone: "Europe/Prague",
  },
  {
    timerect: 1259,
    timereftime: 1049,
    country: "Thailand",
    timestate: "",
    timecity: "Khon Kaen",
    timediff: 420,
    timeZoneTimeAbbreviation: "AsiaICT",
    iana_timezone: "Asia/Bangkok",
  },
  {
    timerect: 1260,
    timereftime: 69,
    country: "Denmark",
    timestate: "",
    timecity: "Copenhagen",
    timediff: 60,
    timeZoneTimeAbbreviation: "EuropeCEST",
    iana_timezone: "Europe/Copenhagen",
  },
  {
    timerect: 1261,
    timereftime: 768,
    country: "TimorLeste",
    timestate: "",
    timecity: "Dili",
    timediff: 540,
    timeZoneTimeAbbreviation: "AsiaTLT",
    iana_timezone: "Asia/Dili",
  },
  {
    timerect: 1262,
    timereftime: 701,
    country: "Denmark",
    timestate: "Faroe Islands",
    timecity: "Tórshavn",
    timediff: 0,
    timeZoneTimeAbbreviation: "EuropeWET",
    iana_timezone: "Atlantic/Faroe",
  },
  {
    timerect: 1263,
    timereftime: 135,
    country: "Togo",
    timestate: "",
    timecity: "Lome",
    timediff: 0,
    timeZoneTimeAbbreviation: "AfricaGMT",
    iana_timezone: "Africa/Lome",
  },
  {
    timerect: 1264,
    timereftime: 697,
    country: "Djibouti",
    timestate: "",
    timecity: "Djibouti",
    timediff: 180,
    timeZoneTimeAbbreviation: "AfricaEAT",
    iana_timezone: "Africa/Djibouti",
  },
  {
    timerect: 1265,
    timereftime: 277,
    country: "Tonga",
    timestate: "",
    timecity: "Nukualofa",
    timediff: 780,
    timeZoneTimeAbbreviation: "AustraliaTOT",
    iana_timezone: "Pacific/Tongatapu",
  },
  {
    timerect: 1266,
    timereftime: 698,
    country: "Dominica",
    timestate: "",
    timecity: "Roseau",
    timediff: -240,
    timeZoneTimeAbbreviation: "AtlanticAST",
    iana_timezone: "America/Dominica",
  },
  {
    timerect: 1267,
    timereftime: 588,
    country: "Trinidad and Tobago",
    timestate: "",
    timecity: "Port of Spain",
    timediff: -240,
    timeZoneTimeAbbreviation: "AtlanticAST",
    iana_timezone: "America/Port_of_Spain",
  },
  {
    timerect: 1268,
    timereftime: 230,
    country: "Dominican Republic",
    timestate: "",
    timecity: "Santo Domingo",
    timediff: -240,
    timeZoneTimeAbbreviation: "AtlanticAST",
    iana_timezone: "America/Santo_Domingo",
  },
  {
    timerect: 1269,
    timereftime: 253,
    country: "Tunisia",
    timestate: "",
    timecity: "Tunis",
    timediff: 60,
    timeZoneTimeAbbreviation: "AfricaCET",
    iana_timezone: "Africa/Tunis",
  },
  {
    timerect: 1270,
    timereftime: 915,
    country: "Ecuador",
    timestate: "",
    timecity: "Galapagos Islands",
    timediff: -360,
    timeZoneTimeAbbreviation: "AmericaGALT",
    iana_timezone: "Pacific/Galapagos",
  },
  {
    timerect: 1271,
    timereftime: 19,
    country: "Turkey",
    timestate: "",
    timecity: "Ankara",
    timediff: 120,
    timeZoneTimeAbbreviation: "EuropeEET",
    iana_timezone: "Europe/Istanbul",
  },
  {
    timerect: 1272,
    timereftime: 93,
    country: "Ecuador",
    timestate: "",
    timecity: "Guayaquil",
    timediff: -300,
    timeZoneTimeAbbreviation: "AmericaECT",
    iana_timezone: "America/Guayaquil",
  },
  {
    timerect: 1273,
    timereftime: 107,
    country: "Turkey",
    timestate: "",
    timecity: "Istanbul",
    timediff: 120,
    timeZoneTimeAbbreviation: "EuropeEET",
    iana_timezone: "Europe/Istanbul",
  },
  {
    timerect: 1274,
    timereftime: 190,
    country: "Ecuador",
    timestate: "",
    timecity: "Quito",
    timediff: -300,
    timeZoneTimeAbbreviation: "AmericaECT",
    iana_timezone: "America/Guayaquil",
  },
  {
    timerect: 1275,
    timereftime: 514,
    country: "Turkey",
    timestate: "",
    timecity: "Izmir",
    timediff: 120,
    timeZoneTimeAbbreviation: "EuropeEET",
    iana_timezone: "Europe/Istanbul",
  },
  {
    timerect: 1276,
    timereftime: 424,
    country: "Egypt",
    timestate: "",
    timecity: "Al Jizah",
    timediff: 120,
    timeZoneTimeAbbreviation: "EuropeEET",
    iana_timezone: "Africa/Cairo",
  },
  {
    timerect: 1277,
    timereftime: 387,
    country: "Turkmenistan",
    timestate: "",
    timecity: "Ashgabat",
    timediff: 300,
    timeZoneTimeAbbreviation: "AsiaTMT",
    iana_timezone: "Asia/Ashgabat",
  },
  {
    timerect: 1278,
    timereftime: 426,
    country: "Egypt",
    timestate: "",
    timecity: "Alexandria",
    timediff: 120,
    timeZoneTimeAbbreviation: "EuropeEET",
    iana_timezone: "Africa/Cairo",
  },
  {
    timerect: 1279,
    timereftime: 272,
    country: "Tuvalu",
    timestate: "",
    timecity: "Funafuti",
    timediff: 720,
    timeZoneTimeAbbreviation: "PacificTVT",
    iana_timezone: "Pacific/Funafuti",
  },
  {
    timerect: 1280,
    timereftime: 53,
    country: "Egypt",
    timestate: "",
    timecity: "Cairo",
    timediff: 120,
    timeZoneTimeAbbreviation: "AfricaEET",
    iana_timezone: "Africa/Cairo",
  },
  {
    timerect: 1281,
    timereftime: 687,
    country: "U.K.",
    timestate: "Anguilla",
    timecity: "The Valley",
    timediff: -240,
    timeZoneTimeAbbreviation: "EuropeGMT",
    iana_timezone: "America/Anguilla",
  },
  {
    timerect: 1282,
    timereftime: 228,
    country: "El Salvador",
    timestate: "",
    timecity: "San Salvador",
    timediff: -360,
    timeZoneTimeAbbreviation: "AmericaCST",
    iana_timezone: "America/El_Salvador",
  },
  {
    timerect: 1283,
    timereftime: 38,
    country: "U.K.",
    timestate: "Bermuda",
    timecity: "Bermuda",
    timediff: -240,
    timeZoneTimeAbbreviation: "AtlanticADT",
    iana_timezone: "Atlantic/Bermuda",
  },
  {
    timerect: 1284,
    timereftime: 229,
    country: "El Salvador",
    timestate: "",
    timecity: "Santa Ana",
    timediff: -360,
    timeZoneTimeAbbreviation: "AmericaPST",
    iana_timezone: "America/El_Salvador",
  },
  {
    timerect: 1285,
    timereftime: 297,
    country: "U.K.",
    timestate: "England",
    timecity: "Birmingham",
    timediff: 0,
    timeZoneTimeAbbreviation: "EuropeGMT",
    iana_timezone: "Europe/London",
  },
  {
    timerect: 1286,
    timereftime: 699,
    country: "Equatorial Guinea",
    timestate: "",
    timecity: "Malabo",
    timediff: 60,
    timeZoneTimeAbbreviation: "AfricaWAT",
    iana_timezone: "Africa/Malabo",
  },
  {
    timerect: 1287,
    timereftime: 301,
    country: "U.K.",
    timestate: "England",
    timecity: "Liverpool",
    timediff: 0,
    timeZoneTimeAbbreviation: "EuropeGMT",
    iana_timezone: "Europe/London",
  },
  {
    timerect: 1288,
    timereftime: 700,
    country: "Eritrea",
    timestate: "",
    timecity: "Asmera",
    timediff: 180,
    timeZoneTimeAbbreviation: "AfricaEAT",
    iana_timezone: "Africa/Asmara",
  },
  {
    timerect: 1289,
    timereftime: 136,
    country: "U.K.",
    timestate: "England",
    timecity: "London",
    timediff: 0,
    timeZoneTimeAbbreviation: "EuropeBST",
    iana_timezone: "Europe/London",
  },
  {
    timerect: 1290,
    timereftime: 242,
    country: "Estonia",
    timestate: "",
    timecity: "Tallinn",
    timediff: 120,
    timeZoneTimeAbbreviation: "EuropeEEST",
    iana_timezone: "Europe/Tallinn",
  },
  {
    timerect: 1291,
    timereftime: 630,
    country: "U.K.",
    timestate: "Falkland Islands",
    timecity: "Stanley",
    timediff: -180,
    timeZoneTimeAbbreviation: "AtlanticFKST",
    iana_timezone: "Atlantic/Stanley",
  },
  {
    timerect: 1292,
    timereftime: 7,
    country: "Ethiopia",
    timestate: "",
    timecity: "Addis Ababa",
    timediff: 180,
    timeZoneTimeAbbreviation: "AfricaEAT",
    iana_timezone: "Africa/Addis_Ababa",
  },
  {
    timerect: 1293,
    timereftime: 89,
    country: "U.K.",
    timestate: "Gibraltar",
    timecity: "Gibraltar",
    timediff: 60,
    timeZoneTimeAbbreviation: "EuropeCEST",
    iana_timezone: "Europe/Gibraltar",
  },
  {
    timerect: 1294,
    timereftime: 82,
    country: "Fiji",
    timestate: "",
    timecity: "Suva",
    timediff: 780,
    timeZoneTimeAbbreviation: "AustraliaFJT",
    iana_timezone: "Pacific/Fiji",
  },
  {
    timerect: 1295,
    timereftime: 377,
    country: "U.K.",
    timestate: "Grand Cayman",
    timecity: "Georgetown",
    timediff: -300,
    timeZoneTimeAbbreviation: "EuropeGMT",
    iana_timezone: "America/Cayman",
  },
  {
    timerect: 1296,
    timereftime: 101,
    country: "Finland",
    timestate: "",
    timecity: "Helsinki",
    timediff: 120,
    timeZoneTimeAbbreviation: "EuropeEEST",
    iana_timezone: "Europe/Helsinki",
  },
  {
    timerect: 1297,
    timereftime: 721,
    country: "U.K.",
    timestate: "Montserrat",
    timecity: "Plymouth",
    timediff: -240,
    timeZoneTimeAbbreviation: "EuropeGMT",
    iana_timezone: "America/Montserrat",
  },
  {
    timerect: 1298,
    timereftime: 1024,
    country: "France",
    timestate: "Corsica",
    timecity: "Bastia",
    timediff: 60,
    timeZoneTimeAbbreviation: "EuropeCET",
    iana_timezone: "Europe/Paris",
  },
  {
    timerect: 1299,
    timereftime: 919,
    country: "U.K.",
    timestate: "Northern Ireland",
    timecity: "Belfast",
    timediff: 0,
    timeZoneTimeAbbreviation: "EuropeGMT",
    iana_timezone: "Europe/London",
  },
  {
    timerect: 1300,
    timereftime: 61,
    country: "France",
    timestate: "French Guiana",
    timecity: "Cayenne",
    timediff: -180,
    timeZoneTimeAbbreviation: "EuropeGFT",
    iana_timezone: "America/Cayenne",
  },
  {
    timerect: 1301,
    timereftime: 755,
    country: "U.K.",
    timestate: "Pitcairn",
    timecity: "Adamstown",
    timediff: -480,
    timeZoneTimeAbbreviation: "EuropeGMT",
    iana_timezone: "Pacific/Pitcairn",
  },
  {
    timerect: 1302,
    timereftime: 1028,
    country: "France",
    timestate: "French Polynesia",
    timecity: "Gambier Islands",
    timediff: -540,
    timeZoneTimeAbbreviation: "EuropeGAMT",
    iana_timezone: "Pacific/Gambier",
  },
  {
    timerect: 1303,
    timereftime: 304,
    country: "U.K.",
    timestate: "Scotland",
    timecity: "Edinburgh",
    timediff: 0,
    timeZoneTimeAbbreviation: "EuropeGMT",
    iana_timezone: "Europe/London",
  },
  {
    timerect: 1304,
    timereftime: 278,
    country: "France",
    timestate: "French Polynesia",
    timecity: "Tahiti - Papeete",
    timediff: -600,
    timeZoneTimeAbbreviation: "EuropeTAHT",
    iana_timezone: "Pacific/Tahiti",
  },
  {
    timerect: 1305,
    timereftime: 90,
    country: "U.K.",
    timestate: "Scotland",
    timecity: "Glasgow",
    timediff: 0,
    timeZoneTimeAbbreviation: "EuropeGMT",
    iana_timezone: "Europe/London",
  },
  {
    timerect: 1306,
    timereftime: 707,
    country: "France",
    timestate: "Guadeloupe",
    timecity: "Basse-Terre",
    timediff: -240,
    timeZoneTimeAbbreviation: "EuropeAST",
    iana_timezone: "America/Guadeloupe",
  },
  {
    timerect: 1307,
    timereftime: 692,
    country: "U.K.",
    timestate: "Virgin Islands",
    timecity: "Road Town",
    timediff: -240,
    timeZoneTimeAbbreviation: "EuropeAST",
    iana_timezone: "America/Tortola",
  },
  {
    timerect: 1308,
    timereftime: 718,
    country: "France",
    timestate: "Martinique",
    timecity: "Fort-de-France",
    timediff: -240,
    timeZoneTimeAbbreviation: "EuropeAST",
    iana_timezone: "America/Martinique",
  },
  {
    timerect: 1309,
    timereftime: 298,
    country: "U.K.",
    timestate: "Wales",
    timecity: "Cardiff",
    timediff: 0,
    timeZoneTimeAbbreviation: "EuropeGMT",
    iana_timezone: "Europe/London",
  },
  {
    timerect: 1310,
    timereftime: 719,
    country: "France",
    timestate: "Mayotte",
    timecity: "Mamoutzou",
    timediff: 180,
    timeZoneTimeAbbreviation: "EuropeEAT",
    iana_timezone: "Indian/Mayotte",
  },
  {
    timerect: 1311,
    timereftime: 408,
    country: "United States of America",
    timestate: "Alabama",
    timecity: "Birmingham",
    timediff: -300,
    timeZoneTimeAbbreviation: "AmericaCST",
    iana_timezone: "America/Chicago",
  },
  {
    timerect: 1312,
    timereftime: 181,
    country: "France",
    timestate: "",
    timecity: "Nice",
    timediff: 60,
    timeZoneTimeAbbreviation: "EuropeCET",
    iana_timezone: "Europe/Paris",
  },
  {
    timerect: 1313,
    timereftime: 406,
    country: "United States of America",
    timestate: "Alabama",
    timecity: "Mobile",
    timediff: -300,
    timeZoneTimeAbbreviation: "AmericaCST",
    iana_timezone: "America/Chicago",
  },
  {
    timerect: 1314,
    timereftime: 723,
    country: "France",
    timestate: "New Caledonia",
    timecity: "Noumea",
    timediff: 660,
    timeZoneTimeAbbreviation: "EuropeSBT",
    iana_timezone: "Pacific/Noumea",
  },
  {
    timerect: 1315,
    timereftime: 407,
    country: "United States of America",
    timestate: "Alabama",
    timecity: "Montgomery",
    timediff: -360,
    timeZoneTimeAbbreviation: "AmericaCST",
    iana_timezone: "America/Chicago",
  },
  {
    timerect: 1316,
    timereftime: 195,
    country: "France",
    timestate: "",
    timecity: "Paris",
    timediff: 60,
    timeZoneTimeAbbreviation: "EuropeCEST",
    iana_timezone: "Europe/Paris",
  },
  {
    timerect: 1317,
    timereftime: 13,
    country: "United States of America",
    timestate: "Alaska",
    timecity: "Adak",
    timediff: -600,
    timeZoneTimeAbbreviation: "AmericaHST",
    iana_timezone: "America/Adak",
  },
  {
    timerect: 1318,
    timereftime: 1027,
    country: "France",
    timestate: "French Polynesia",
    timecity: "Marquesas Islands - Taiohae",
    timediff: -570,
    timeZoneTimeAbbreviation: "EuropeTAHT",
    iana_timezone: "Pacific/Marquesas",
  },
  {
    timerect: 1319,
    timereftime: 18,
    country: "United States of America",
    timestate: "Alaska",
    timecity: "Anchorage",
    timediff: -540,
    timeZoneTimeAbbreviation: "AmericaAKDT",
    iana_timezone: "America/Anchorage",
  },
  {
    timerect: 1320,
    timereftime: 397,
    country: "France",
    timestate: "Kerguelen",
    timecity: "Port-aux-Francais",
    timediff: 300,
    timeZoneTimeAbbreviation: "EuropeTFT",
    iana_timezone: "Indian/Kerguelen",
  },
  {
    timerect: 1321,
    timereftime: 81,
    country: "United States of America",
    timestate: "Alaska",
    timecity: "Fairbanks",
    timediff: -540,
    timeZoneTimeAbbreviation: "AmericaAKST",
    iana_timezone: "America/Anchorage",
  },
  {
    timerect: 1322,
    timereftime: 129,
    country: "Gabon",
    timestate: "",
    timecity: "Libreville",
    timediff: 60,
    timeZoneTimeAbbreviation: "AfricaWAT",
    iana_timezone: "Africa/Libreville",
  },
  {
    timerect: 1323,
    timereftime: 112,
    country: "United States of America",
    timestate: "Alaska",
    timecity: "Juneau",
    timediff: -480,
    timeZoneTimeAbbreviation: "AmericaAKDT",
    iana_timezone: "America/Juneau",
  },
  {
    timerect: 1324,
    timereftime: 30,
    country: "Gambia",
    timestate: "",
    timecity: "Banjul",
    timediff: 0,
    timeZoneTimeAbbreviation: "AfricaGMT",
    iana_timezone: "Africa/Banjul",
  },
  {
    timerect: 1325,
    timereftime: 182,
    country: "United States of America",
    timestate: "Alaska",
    timecity: "Nome",
    timediff: -480,
    timeZoneTimeAbbreviation: "AmericaAKDT",
    iana_timezone: "America/Nome",
  },
  {
    timerect: 1326,
    timereftime: 702,
    country: "Gaza Strip",
    timestate: "",
    timecity: "Gaza",
    timediff: 120,
    timeZoneTimeAbbreviation: "AsiaEEST",
    iana_timezone: "Asia/Gaza",
  },
  {
    timerect: 1327,
    timereftime: 931,
    country: "United States of America",
    timestate: "Alaska",
    timecity: "Unalaska",
    timediff: -540,
    timeZoneTimeAbbreviation: "AmericaAKST",
    iana_timezone: "America/Adak",
  },
  {
    timerect: 1328,
    timereftime: 371,
    country: "Georgia",
    timestate: "",
    timecity: "Tbilisi",
    timediff: 240,
    timeZoneTimeAbbreviation: "AsiaGET",
    iana_timezone: "Asia/Tbilisi",
  },
  {
    timerect: 1329,
    timereftime: 1033,
    country: "United States of America",
    timestate: "American Samoa",
    timecity: "Pago Pago",
    timediff: -660,
    timeZoneTimeAbbreviation: "AmericaSST",
    iana_timezone: "Pacific/Pago_Pago",
  },
  {
    timerect: 1330,
    timereftime: 168,
    country: "Germany",
    timestate: "Bayern",
    timecity: "Munich",
    timediff: 60,
    timeZoneTimeAbbreviation: "EuropeCET",
    iana_timezone: "Europe/Berlin",
  },
  {
    timerect: 1331,
    timereftime: 853,
    country: "United States of America",
    timestate: "Arizona",
    timecity: "Mesa",
    timediff: -420,
    timeZoneTimeAbbreviation: "AmericaMST",
    iana_timezone: "America/Phoenix",
  },
  {
    timerect: 1332,
    timereftime: 37,
    country: "Germany",
    timestate: "Berlin",
    timecity: "Berlin",
    timediff: 60,
    timeZoneTimeAbbreviation: "EuropeCEST",
    iana_timezone: "Europe/Berlin",
  },
  {
    timerect: 1333,
    timereftime: 197,
    country: "United States of America",
    timestate: "Arizona",
    timecity: "Phoenix",
    timediff: -420,
    timeZoneTimeAbbreviation: "AmericaMST",
    iana_timezone: "America/Phoenix",
  },
  {
    timerect: 1334,
    timereftime: 307,
    country: "Germany",
    timestate: "Hamburg",
    timecity: "Hamburg",
    timediff: 60,
    timeZoneTimeAbbreviation: "EuropeCET",
    iana_timezone: "Europe/Berlin",
  },
  {
    timerect: 1335,
    timereftime: 393,
    country: "United States of America",
    timestate: "Arizona",
    timecity: "Tucson",
    timediff: -420,
    timeZoneTimeAbbreviation: "AmericaMST",
    iana_timezone: "America/Phoenix",
  },
  {
    timerect: 1336,
    timereftime: 83,
    country: "Germany",
    timestate: "Hessen",
    timecity: "Frankfurt",
    timediff: 60,
    timeZoneTimeAbbreviation: "EuropeCET",
    iana_timezone: "Europe/Berlin",
  },
  {
    timerect: 1337,
    timereftime: 134,
    country: "United States of America",
    timestate: "Arkansas",
    timecity: "Little Rock",
    timediff: -360,
    timeZoneTimeAbbreviation: "AmericaCST",
    iana_timezone: "America/Chicago",
  },
  {
    timerect: 1338,
    timereftime: 79,
    country: "Germany",
    timestate: "NordrheinWestfalen",
    timecity: "Düsseldorf",
    timediff: 60,
    timeZoneTimeAbbreviation: "EuropeCET",
    iana_timezone: "Europe/Berlin",
  },
  {
    timerect: 1339,
    timereftime: 783,
    country: "United States of America",
    timestate: "California",
    timecity: "Anaheim",
    timediff: -420,
    timeZoneTimeAbbreviation: "AmericaPST",
    iana_timezone: "America/Los_Angeles",
  },
  {
    timerect: 1340,
    timereftime: 4,
    country: "Ghana",
    timestate: "",
    timecity: "Accra",
    timediff: 0,
    timeZoneTimeAbbreviation: "AfricaGMT",
    iana_timezone: "Africa/Accra",
  },
  {
    timerect: 1341,
    timereftime: 850,
    country: "United States of America",
    timestate: "California",
    timecity: "Long Beach",
    timediff: -480,
    timeZoneTimeAbbreviation: "AmericaPST",
    iana_timezone: "America/Los_Angeles",
  },
  {
    timerect: 1342,
    timereftime: 26,
    country: "Greece",
    timestate: "",
    timecity: "Athens",
    timediff: 120,
    timeZoneTimeAbbreviation: "EuropeEEST",
    iana_timezone: "Europe/Athens",
  },
  {
    timerect: 1343,
    timereftime: 137,
    country: "United States of America",
    timestate: "California",
    timecity: "Los Angeles",
    timediff: -480,
    timeZoneTimeAbbreviation: "AmericaPST",
    iana_timezone: "America/Los_Angeles",
  },
  {
    timerect: 1344,
    timereftime: 706,
    country: "Grenada",
    timestate: "",
    timecity: "Saint George's",
    timediff: -240,
    timeZoneTimeAbbreviation: "AtlanticAST",
    iana_timezone: "America/Grenada",
  },
  {
    timerect: 1345,
    timereftime: 388,
    country: "United States of America",
    timestate: "California",
    timecity: "Oakland",
    timediff: -480,
    timeZoneTimeAbbreviation: "AmericaPST",
    iana_timezone: "America/Los_Angeles",
  },
  {
    timerect: 1346,
    timereftime: 94,
    country: "Guatemala",
    timestate: "",
    timecity: "Guatemala",
    timediff: -360,
    timeZoneTimeAbbreviation: "AmericaCST",
    iana_timezone: "America/Guatemala",
  },
  {
    timerect: 1347,
    timereftime: 880,
    country: "United States of America",
    timestate: "California",
    timecity: "Riverside",
    timediff: -420,
    timeZoneTimeAbbreviation: "AmericaPST",
    iana_timezone: "America/Los_Angeles",
  },
  {
    timerect: 1348,
    timereftime: 67,
    country: "Guinea",
    timestate: "",
    timecity: "Conakry",
    timediff: 0,
    timeZoneTimeAbbreviation: "AfricaGMT",
    iana_timezone: "Africa/Conakry",
  },
  {
    timerect: 1349,
    timereftime: 217,
    country: "United States of America",
    timestate: "California",
    timecity: "Sacramento",
    timediff: -480,
    timeZoneTimeAbbreviation: "AmericaPST",
    iana_timezone: "America/Los_Angeles",
  },
  {
    timerect: 1350,
    timereftime: 40,
    country: "Guinea Bissau",
    timestate: "",
    timecity: "Bissau",
    timediff: 0,
    timeZoneTimeAbbreviation: "AfricaGMT",
    iana_timezone: "Africa/Bissau",
  },
  {
    timerect: 1351,
    timereftime: 770,
    country: "United States of America",
    timestate: "California",
    timecity: "San Diego",
    timediff: -480,
    timeZoneTimeAbbreviation: "AmericaPST",
    iana_timezone: "America/Los_Angeles",
  },
  {
    timerect: 1352,
    timereftime: 88,
    country: "Guyana",
    timestate: "",
    timecity: "Georgetown",
    timediff: -240,
    timeZoneTimeAbbreviation: "AmericaGYT",
    iana_timezone: "America/Guyana",
  },
  {
    timerect: 1353,
    timereftime: 224,
    country: "United States of America",
    timestate: "California",
    timecity: "San Francisco",
    timediff: -480,
    timeZoneTimeAbbreviation: "AmericaPST",
    iana_timezone: "America/Los_Angeles",
  },
  {
    timerect: 1354,
    timereftime: 709,
    country: "Haiti",
    timestate: "",
    timecity: "Portau-Prince",
    timediff: -300,
    timeZoneTimeAbbreviation: "AmericaEST",
    iana_timezone: "America/Port-au-Prince",
  },
  {
    timerect: 1355,
    timereftime: 283,
    country: "United States of America",
    timestate: "California",
    timecity: "San Jose",
    timediff: -480,
    timeZoneTimeAbbreviation: "AmericaPST",
    iana_timezone: "America/Los_Angeles",
  },
  {
    timerect: 1356,
    timereftime: 245,
    country: "Honduras",
    timestate: "",
    timecity: "Tegucigalpa",
    timediff: -360,
    timeZoneTimeAbbreviation: "AmericaCST",
    iana_timezone: "America/Tegucigalpa",
  },
  {
    timerect: 1357,
    timereftime: 899,
    country: "United States of America",
    timestate: "California",
    timecity: "Stockton",
    timediff: -420,
    timeZoneTimeAbbreviation: "AmericaPST",
    iana_timezone: "America/Los_Angeles",
  },
  {
    timerect: 1358,
    timereftime: 50,
    country: "Hungary",
    timestate: "",
    timecity: "Budapest",
    timediff: 60,
    timeZoneTimeAbbreviation: "EuropeCEST",
    iana_timezone: "Europe/Budapest",
  },
  {
    timerect: 1359,
    timereftime: 787,
    country: "United States of America",
    timestate: "Colorado",
    timecity: "Aurora",
    timediff: -360,
    timeZoneTimeAbbreviation: "AmericaMST",
    iana_timezone: "America/Denver",
  },
  {
    timerect: 1360,
    timereftime: 211,
    country: "Iceland",
    timestate: "",
    timecity: "Reykjavik",
    timediff: 0,
    timeZoneTimeAbbreviation: "AtlanticGMT",
    iana_timezone: "Atlantic/Reykjavik",
  },
  {
    timerect: 1361,
    timereftime: 75,
    country: "United States of America",
    timestate: "Colorado",
    timecity: "Denver",
    timediff: -420,
    timeZoneTimeAbbreviation: "AmericaMDT",
    iana_timezone: "America/Denver",
  },
  {
    timerect: 1362,
    timereftime: 1046,
    country: "India",
    timestate: "",
    timecity: "Agra",
    timediff: 330,
    timeZoneTimeAbbreviation: "AsiaIST",
    iana_timezone: "Asia/Kolkata",
  },
  {
    timerect: 1363,
    timereftime: 98,
    country: "United States of America",
    timestate: "Connecticut",
    timecity: "Hartford",
    timediff: -300,
    timeZoneTimeAbbreviation: "AmericaEST",
    iana_timezone: "America/New_York",
  },
  {
    timerect: 1364,
    timereftime: 423,
    country: "India",
    timestate: "",
    timecity: "Ahmadãbãd",
    timediff: 330,
    timeZoneTimeAbbreviation: "AsiaIST",
    iana_timezone: "Asia/Kolkata",
  },
  {
    timerect: 1365,
    timereftime: 1029,
    country: "United States of America",
    timestate: "Delaware",
    timecity: "Dover",
    timediff: -300,
    timeZoneTimeAbbreviation: "AmericaGMT",
    iana_timezone: "America/New_York",
  },
  {
    timerect: 1366,
    timereftime: 438,
    country: "India",
    timestate: "",
    timecity: "Bangalore",
    timediff: 330,
    timeZoneTimeAbbreviation: "AsiaIST",
    iana_timezone: "Asia/Kolkata",
  },
  {
    timerect: 1367,
    timereftime: 263,
    country: "United States of America",
    timestate: "District of Columbia",
    timecity: "Washington DC",
    timediff: -300,
    timeZoneTimeAbbreviation: "AmericaEST",
    iana_timezone: "America/New_York",
  },
  {
    timerect: 1368,
    timereftime: 1042,
    country: "India",
    timestate: "",
    timecity: "Bhubaneshwar",
    timediff: 330,
    timeZoneTimeAbbreviation: "AsiaIST",
    iana_timezone: "Asia/Kolkata",
  },
  {
    timerect: 1369,
    timereftime: 411,
    country: "United States of America",
    timestate: "Florida",
    timecity: "Jacksonville",
    timediff: -300,
    timeZoneTimeAbbreviation: "AmericaEST",
    iana_timezone: "America/New_York",
  },
  {
    timerect: 1370,
    timereftime: 553,
    country: "India",
    timestate: "",
    timecity: "Chennai",
    timediff: 330,
    timeZoneTimeAbbreviation: "AsiaIST",
    iana_timezone: "Asia/Kolkata",
  },
  {
    timerect: 1371,
    timereftime: 156,
    country: "United States of America",
    timestate: "Florida",
    timecity: "Miami",
    timediff: -300,
    timeZoneTimeAbbreviation: "AmericaEST",
    iana_timezone: "America/New_York",
  },
  {
    timerect: 1372,
    timereftime: 771,
    country: "India",
    timestate: "",
    timecity: "Delhi",
    timediff: 330,
    timeZoneTimeAbbreviation: "AsiaIST",
    iana_timezone: "Asia/Kolkata",
  },
  {
    timerect: 1373,
    timereftime: 944,
    country: "United States of America",
    timestate: "Florida",
    timecity: "Pensacola",
    timediff: -360,
    timeZoneTimeAbbreviation: "AmericaCST",
    iana_timezone: "America/Chicago",
  },
  {
    timerect: 1374,
    timereftime: 505,
    country: "India",
    timestate: "",
    timecity: "Hyderãbãd",
    timediff: 330,
    timeZoneTimeAbbreviation: "AsiaIST",
    iana_timezone: "Asia/Kolkata",
  },
  {
    timerect: 1375,
    timereftime: 896,
    country: "United States of America",
    timestate: "Florida",
    timecity: "St. Petersburg",
    timediff: -240,
    timeZoneTimeAbbreviation: "EuropeMSK",
    iana_timezone: "America/New_York",
  },
  {
    timerect: 1376,
    timereftime: 1041,
    country: "India",
    timestate: "",
    timecity: "Indore",
    timediff: 330,
    timeZoneTimeAbbreviation: "AsiaISE",
    iana_timezone: "Asia/Kolkata",
  },
  {
    timerect: 1377,
    timereftime: 410,
    country: "United States of America",
    timestate: "Florida",
    timecity: "Tampa",
    timediff: -300,
    timeZoneTimeAbbreviation: "AmericaEST",
    iana_timezone: "America/New_York",
  },
  {
    timerect: 1378,
    timereftime: 516,
    country: "India",
    timestate: "",
    timecity: "Jaipur",
    timediff: 330,
    timeZoneTimeAbbreviation: "AsiaIST",
    iana_timezone: "Asia/Kolkata",
  },
  {
    timerect: 1379,
    timereftime: 25,
    country: "United States of America",
    timestate: "Georgia",
    timecity: "Atlanta",
    timediff: -300,
    timeZoneTimeAbbreviation: "AmericaEST",
    iana_timezone: "America/New_York",
  },
  {
    timerect: 1380,
    timereftime: 54,
    country: "India",
    timestate: "",
    timecity: "Kolkata",
    timediff: 330,
    timeZoneTimeAbbreviation: "AsiaIST",
    iana_timezone: "Asia/Kolkata",
  },
  {
    timerect: 1381,
    timereftime: 103,
    country: "United States of America",
    timestate: "Hawaii",
    timecity: "Honolulu",
    timediff: -600,
    timeZoneTimeAbbreviation: "AmericaHST",
    iana_timezone: "Pacific/Honolulu",
  },
  {
    timerect: 1382,
    timereftime: 539,
    country: "India",
    timestate: "",
    timecity: "Kãnpur",
    timediff: 330,
    timeZoneTimeAbbreviation: "AsiaIST",
    iana_timezone: "Asia/Kolkata",
  },
  {
    timerect: 1383,
    timereftime: 42,
    country: "United States of America",
    timestate: "Idaho",
    timecity: "Boise",
    timediff: -420,
    timeZoneTimeAbbreviation: "AmericaMDT",
    iana_timezone: "America/Boise",
  },
  {
    timerect: 1384,
    timereftime: 545,
    country: "India",
    timestate: "",
    timecity: "Lucknow",
    timediff: 330,
    timeZoneTimeAbbreviation: "AsiaIST",
    iana_timezone: "Asia/Kolkata",
  },
  {
    timerect: 1385,
    timereftime: 64,
    country: "United States of America",
    timestate: "Illinois",
    timecity: "Chicago",
    timediff: -360,
    timeZoneTimeAbbreviation: "AmericaCDT",
    iana_timezone: "America/Chicago",
  },
  {
    timerect: 1386,
    timereftime: 1043,
    country: "India",
    timestate: "",
    timecity: "Ludhiana",
    timediff: 330,
    timeZoneTimeAbbreviation: "AsiaIST",
    iana_timezone: "Asia/Kolkata",
  },
  {
    timerect: 1387,
    timereftime: 105,
    country: "United States of America",
    timestate: "Indiana",
    timecity: "Indianapolis",
    timediff: -300,
    timeZoneTimeAbbreviation: "AmericaEST",
    iana_timezone: "America/Indianapolis",
  },
  {
    timerect: 1388,
    timereftime: 1047,
    country: "India",
    timestate: "",
    timecity: "Madurai",
    timediff: 330,
    timeZoneTimeAbbreviation: "AsiaIST",
    iana_timezone: "Asia/Kolkata",
  },
  {
    timerect: 1389,
    timereftime: 76,
    country: "United States of America",
    timestate: "Iowa",
    timecity: "Des Moines",
    timediff: -360,
    timeZoneTimeAbbreviation: "AmericaCST",
    iana_timezone: "America/Chicago",
  },
  {
    timerect: 1390,
    timereftime: 44,
    country: "India",
    timestate: "",
    timecity: "Mumbai",
    timediff: 330,
    timeZoneTimeAbbreviation: "AsiaIST",
    iana_timezone: "Asia/Kolkata",
  },
  {
    timerect: 1391,
    timereftime: 249,
    country: "United States of America",
    timestate: "Kansas",
    timecity: "Topeka",
    timediff: -360,
    timeZoneTimeAbbreviation: "AmericaCST",
    iana_timezone: "America/Chicago",
  },
  {
    timerect: 1392,
    timereftime: 176,
    country: "India",
    timestate: "",
    timecity: "New Delhi",
    timediff: 330,
    timeZoneTimeAbbreviation: "AsiaIST",
    iana_timezone: "Asia/Kolkata",
  },
  {
    timerect: 1393,
    timereftime: 403,
    country: "United States of America",
    timestate: "Kansas",
    timecity: "Wichita",
    timediff: -360,
    timeZoneTimeAbbreviation: "AmericaCST",
    iana_timezone: "America/Chicago",
  },
  {
    timerect: 1394,
    timereftime: 571,
    country: "India",
    timestate: "",
    timecity: "Nãgpur",
    timediff: 330,
    timeZoneTimeAbbreviation: "AsiaIST",
    iana_timezone: "Asia/Kolkata",
  },
  {
    timerect: 1395,
    timereftime: 84,
    country: "United States of America",
    timestate: "Kentucky",
    timecity: "Frankfort",
    timediff: -300,
    timeZoneTimeAbbreviation: "AmericaEST",
    iana_timezone: "America/New_York",
  },
  {
    timerect: 1396,
    timereftime: 1040,
    country: "India",
    timestate: "",
    timecity: "Patna",
    timediff: 330,
    timeZoneTimeAbbreviation: "AsiaIST",
    iana_timezone: "Asia/Kolkata",
  },
  {
    timerect: 1397,
    timereftime: 848,
    country: "United States of America",
    timestate: "Kentucky",
    timecity: "Lexington-Fayette",
    timediff: -240,
    timeZoneTimeAbbreviation: "AmericaEST",
    iana_timezone: "America/New_York",
  },
  {
    timerect: 1398,
    timereftime: 1038,
    country: "India",
    timestate: "",
    timecity: "Pune",
    timediff: 330,
    timeZoneTimeAbbreviation: "AsiaIST",
    iana_timezone: "Asia/Kolkata",
  },
  {
    timerect: 1399,
    timereftime: 413,
    country: "United States of America",
    timestate: "Kentucky",
    timecity: "Louisville",
    timediff: -300,
    timeZoneTimeAbbreviation: "AmericaEST",
    iana_timezone: "America/New_York",
  },
  {
    timerect: 1400,
    timereftime: 1039,
    country: "India",
    timestate: "",
    timecity: "Surat",
    timediff: 330,
    timeZoneTimeAbbreviation: "AsiaIST",
    iana_timezone: "Asia/Kolkata",
  },
  {
    timerect: 1401,
    timereftime: 32,
    country: "United States of America",
    timestate: "Louisiana",
    timecity: "Baton Rouge",
    timediff: -360,
    timeZoneTimeAbbreviation: "AmericaCST",
    iana_timezone: "America/Chicago",
  },
  {
    timerect: 1402,
    timereftime: 925,
    country: "India",
    timestate: "",
    timecity: "Vadodara",
    timediff: 330,
    timeZoneTimeAbbreviation: "AsiaIST",
    iana_timezone: "Asia/Kolkata",
  },
  {
    timerect: 1403,
    timereftime: 178,
    country: "United States of America",
    timestate: "Louisiana",
    timecity: "New Orleans",
    timediff: -360,
    timeZoneTimeAbbreviation: "AmericaCST",
    iana_timezone: "America/Chicago",
  },
  {
    timerect: 1404,
    timereftime: 1045,
    country: "India",
    timestate: "",
    timecity: "Varanasi",
    timediff: 330,
    timeZoneTimeAbbreviation: "AsiaIST",
    iana_timezone: "Asia/Kolkata",
  },
  {
    timerect: 1405,
    timereftime: 23,
    country: "United States of America",
    timestate: "Maine",
    timecity: "Augusta",
    timediff: -300,
    timeZoneTimeAbbreviation: "AmericaEST",
    iana_timezone: "America/New_York",
  },
  {
    timerect: 1406,
    timereftime: 1044,
    country: "India",
    timestate: "",
    timecity: "Vishakhapatnam",
    timediff: 330,
    timeZoneTimeAbbreviation: "AsiaIST",
    iana_timezone: "Asia/Kolkata",
  },
  {
    timerect: 1407,
    timereftime: 91,
    country: "United States of America",
    timestate: "Mariana Islands",
    timecity: "Guam",
    timediff: 600,
    timeZoneTimeAbbreviation: "AmericaChST",
    iana_timezone: "Pacific/Guam",
  },
  {
    timerect: 1408,
    timereftime: 761,
    country: "Indonesia",
    timestate: "Bali",
    timecity: "Denpasar",
    timediff: 480,
    timeZoneTimeAbbreviation: "AsiaWITA",
    iana_timezone: "Asia/Makassar",
  },
  {
    timerect: 1409,
    timereftime: 419,
    country: "United States of America",
    timestate: "Maryland",
    timecity: "Baltimore",
    timediff: -300,
    timeZoneTimeAbbreviation: "AmericaEST",
    iana_timezone: "America/New_York",
  },
  {
    timerect: 1410,
    timereftime: 760,
    country: "Indonesia",
    timestate: "Bali",
    timecity: "Singaraja",
    timediff: 480,
    timeZoneTimeAbbreviation: "AsiaWITA",
    iana_timezone: "Asia/Makassar",
  },
  {
    timerect: 1411,
    timereftime: 43,
    country: "United States of America",
    timestate: "Massachusetts",
    timecity: "Boston",
    timediff: -300,
    timeZoneTimeAbbreviation: "AmericaEST",
    iana_timezone: "America/New_York",
  },
  {
    timerect: 1412,
    timereftime: 764,
    country: "Indonesia",
    timestate: "Flores",
    timecity: "Endeh",
    timediff: 480,
    timeZoneTimeAbbreviation: "AsiaWITA",
    iana_timezone: "Asia/Makassar",
  },
  {
    timerect: 1413,
    timereftime: 77,
    country: "United States of America",
    timestate: "Michigan",
    timecity: "Detroit",
    timediff: -300,
    timeZoneTimeAbbreviation: "AmericaEDT",
    iana_timezone: "America/Detroit",
  },
  {
    timerect: 1414,
    timereftime: 767,
    country: "Indonesia",
    timestate: "Halmahera",
    timecity: "Ternate",
    timediff: 540,
    timeZoneTimeAbbreviation: "AsiaWIT",
    iana_timezone: "Asia/Jayapura",
  },
  {
    timerect: 1415,
    timereftime: 159,
    country: "United States of America",
    timestate: "Minnesota",
    timecity: "Minneapolis",
    timediff: -360,
    timeZoneTimeAbbreviation: "AmericaCST",
    iana_timezone: "America/Chicago",
  },
  {
    timerect: 1416,
    timereftime: 437,
    country: "Indonesia",
    timestate: "Java",
    timecity: "Bandung",
    timediff: 420,
    timeZoneTimeAbbreviation: "AsiaWIB",
    iana_timezone: "Asia/Jakarta",
  },
  {
    timerect: 1417,
    timereftime: 219,
    country: "United States of America",
    timestate: "Minnesota",
    timecity: "St. Paul",
    timediff: -360,
    timeZoneTimeAbbreviation: "AmericaCST",
    iana_timezone: "America/Chicago",
  },
  {
    timerect: 1418,
    timereftime: 108,
    country: "Indonesia",
    timestate: "Java",
    timecity: "Jakarta",
    timediff: 420,
    timeZoneTimeAbbreviation: "AsiaWIB",
    iana_timezone: "Asia/Jakarta",
  },
  {
    timerect: 1419,
    timereftime: 515,
    country: "United States of America",
    timestate: "Mississippi",
    timecity: "Jackson",
    timediff: -360,
    timeZoneTimeAbbreviation: "AmericaCST",
    iana_timezone: "America/Chicago",
  },
  {
    timerect: 1420,
    timereftime: 554,
    country: "Indonesia",
    timestate: "Java",
    timecity: "Malang",
    timediff: 420,
    timeZoneTimeAbbreviation: "AsiaWIB",
    iana_timezone: "Asia/Jakarta",
  },
  {
    timerect: 1421,
    timereftime: 109,
    country: "United States of America",
    timestate: "Missouri",
    timecity: "Jefferson City",
    timediff: -360,
    timeZoneTimeAbbreviation: "AmericaCST",
    iana_timezone: "America/Chicago",
  },
  {
    timerect: 1422,
    timereftime: 624,
    country: "Indonesia",
    timestate: "Java",
    timecity: "Semarang",
    timediff: 420,
    timeZoneTimeAbbreviation: "AsiaWIB",
    iana_timezone: "Asia/Jakarta",
  },
  {
    timerect: 1423,
    timereftime: 405,
    country: "United States of America",
    timestate: "Missouri",
    timecity: "Kansas City",
    timediff: -360,
    timeZoneTimeAbbreviation: "AmericaCST",
    iana_timezone: "America/Chicago",
  },
  {
    timerect: 1424,
    timereftime: 631,
    country: "Indonesia",
    timestate: "Java",
    timecity: "Surabaya",
    timediff: 420,
    timeZoneTimeAbbreviation: "AsiaWIB",
    iana_timezone: "Asia/Jakarta",
  },
  {
    timerect: 1425,
    timereftime: 605,
    country: "United States of America",
    timestate: "Missouri",
    timecity: "St. Louis",
    timediff: -360,
    timeZoneTimeAbbreviation: "AmericaCST",
    iana_timezone: "America/Chicago",
  },
  {
    timerect: 1426,
    timereftime: 632,
    country: "Indonesia",
    timestate: "Java",
    timecity: "Surakarta",
    timediff: 420,
    timeZoneTimeAbbreviation: "AsiaWIB",
    iana_timezone: "Asia/Jakarta",
  },
  {
    timerect: 1427,
    timereftime: 448,
    country: "United States of America",
    timestate: "Montana",
    timecity: "Billings",
    timediff: -420,
    timeZoneTimeAbbreviation: "AmericaMST",
    iana_timezone: "America/Denver",
  },
  {
    timerect: 1428,
    timereftime: 434,
    country: "Indonesia",
    timestate: "Kalimantan",
    timecity: "Balikpapan",
    timediff: 480,
    timeZoneTimeAbbreviation: "AsiaWITA",
    iana_timezone: "Asia/Makassar",
  },
  {
    timerect: 1429,
    timereftime: 100,
    country: "United States of America",
    timestate: "Montana",
    timecity: "Helena",
    timediff: -420,
    timeZoneTimeAbbreviation: "AmericaMST",
    iana_timezone: "America/Denver",
  },
  {
    timerect: 1430,
    timereftime: 765,
    country: "Indonesia",
    timestate: "Lombok",
    timecity: "Mataram",
    timediff: 480,
    timeZoneTimeAbbreviation: "AsiaWITA",
    iana_timezone: "Asia/Makassar",
  },
  {
    timerect: 1431,
    timereftime: 132,
    country: "United States of America",
    timestate: "Nebraska",
    timecity: "Lincoln",
    timediff: -360,
    timeZoneTimeAbbreviation: "AmericaCST",
    iana_timezone: "America/Chicago",
  },
  {
    timerect: 1432,
    timereftime: 759,
    country: "Indonesia",
    timestate: "Papua",
    timecity: "Jayapura",
    timediff: 540,
    timeZoneTimeAbbreviation: "AsiaWIT",
    iana_timezone: "Asia/Jayapura",
  },
  {
    timerect: 1433,
    timereftime: 59,
    country: "United States of America",
    timestate: "Nevada",
    timecity: "Carson City",
    timediff: -480,
    timeZoneTimeAbbreviation: "AmericaPST",
    iana_timezone: "America/Los_Angeles",
  },
  {
    timerect: 1434,
    timereftime: 766,
    country: "Indonesia",
    timestate: "Seram",
    timecity: "Ambon",
    timediff: 540,
    timeZoneTimeAbbreviation: "AsiaWIT",
    iana_timezone: "Asia/Jayapura",
  },
  {
    timerect: 1435,
    timereftime: 127,
    country: "United States of America",
    timestate: "Nevada",
    timecity: "Las Vegas",
    timediff: -480,
    timeZoneTimeAbbreviation: "AmericaPST",
    iana_timezone: "America/Los_Angeles",
  },
  {
    timerect: 1436,
    timereftime: 555,
    country: "Indonesia",
    timestate: "Sulawesi",
    timecity: "Manado",
    timediff: 480,
    timeZoneTimeAbbreviation: "AsiaWITA",
    iana_timezone: "Asia/Makassar",
  },
  {
    timerect: 1437,
    timereftime: 68,
    country: "United States of America",
    timestate: "New Hampshire",
    timecity: "Concord",
    timediff: -300,
    timeZoneTimeAbbreviation: "AmericaPST",
    iana_timezone: "America/New_York",
  },
  {
    timerect: 1438,
    timereftime: 561,
    country: "Indonesia",
    timestate: "Sumatera",
    timecity: "Medan",
    timediff: 420,
    timeZoneTimeAbbreviation: "AsiaWIB",
    iana_timezone: "Asia/Jakarta",
  },
  {
    timerect: 1439,
    timereftime: 842,
    country: "United States of America",
    timestate: "New Jersey",
    timecity: "Jersey City",
    timediff: -240,
    timeZoneTimeAbbreviation: "AmericaEST",
    iana_timezone: "America/New_York",
  },
  {
    timerect: 1440,
    timereftime: 576,
    country: "Indonesia",
    timestate: "Sumatera",
    timecity: "Palembang",
    timediff: 420,
    timeZoneTimeAbbreviation: "AsiaWIB",
    iana_timezone: "Asia/Jakarta",
  },
  {
    timerect: 1441,
    timereftime: 861,
    country: "United States of America",
    timestate: "New Jersey",
    timecity: "Newark",
    timediff: -300,
    timeZoneTimeAbbreviation: "AmericaEST",
    iana_timezone: "America/New_York",
  },
  {
    timerect: 1442,
    timereftime: 763,
    country: "Indonesia",
    timestate: "Sumbawa",
    timecity: "Raba",
    timediff: 480,
    timeZoneTimeAbbreviation: "AsiaWITA",
    iana_timezone: "Asia/Makassar",
  },
  {
    timerect: 1443,
    timereftime: 251,
    country: "United States of America",
    timestate: "New Jersey",
    timecity: "Trenton",
    timediff: -300,
    timeZoneTimeAbbreviation: "AmericaEST",
    iana_timezone: "America/New_York",
  },
  {
    timerect: 1444,
    timereftime: 762,
    country: "Indonesia",
    timestate: "West Timor",
    timecity: "Kupang",
    timediff: 480,
    timeZoneTimeAbbreviation: "AsiaWITA",
    iana_timezone: "Asia/Makassar",
  },
  {
    timerect: 1445,
    timereftime: 394,
    country: "United States of America",
    timestate: "New Mexico",
    timecity: "Albuquerque",
    timediff: -420,
    timeZoneTimeAbbreviation: "AmericaMST",
    iana_timezone: "America/Denver",
  },
  {
    timerect: 1446,
    timereftime: 1061,
    country: "Iran",
    timestate: "",
    timecity: "Esfahãn",
    timediff: 210,
    timeZoneTimeAbbreviation: "AsiaIRST",
    iana_timezone: "Asia/Tehran",
  },
  {
    timerect: 1447,
    timereftime: 231,
    country: "United States of America",
    timestate: "New Mexico",
    timecity: "Santa Fe",
    timediff: -420,
    timeZoneTimeAbbreviation: "AmericaMST",
    iana_timezone: "America/Denver",
  },
  {
    timerect: 1448,
    timereftime: 246,
    country: "Iran",
    timestate: "",
    timecity: "Tehran",
    timediff: 210,
    timeZoneTimeAbbreviation: "AsiaIRST",
    iana_timezone: "Asia/Tehran",
  },
  {
    timerect: 1449,
    timereftime: 12,
    country: "United States of America",
    timestate: "New York",
    timecity: "Albany",
    timediff: -300,
    timeZoneTimeAbbreviation: "AmericaEST",
    iana_timezone: "America/New_York",
  },
  {
    timerect: 1450,
    timereftime: 27,
    country: "Iraq",
    timestate: "",
    timecity: "Baghdad",
    timediff: 180,
    timeZoneTimeAbbreviation: "AsiaAST",
    iana_timezone: "Asia/Baghdad",
  },
  {
    timerect: 1451,
    timereftime: 422,
    country: "United States of America",
    timestate: "New York",
    timecity: "Buffalo",
    timediff: -240,
    timeZoneTimeAbbreviation: "AmericaEST",
    iana_timezone: "America/New_York",
  },
  {
    timerect: 1452,
    timereftime: 1051,
    country: "Iraq",
    timestate: "",
    timecity: "Basra",
    timediff: 180,
    timeZoneTimeAbbreviation: "AsiaAST",
    iana_timezone: "Asia/Baghdad",
  },
  {
    timerect: 1453,
    timereftime: 179,
    country: "United States of America",
    timestate: "New York",
    timecity: "New York",
    timediff: -300,
    timeZoneTimeAbbreviation: "AmericaEST",
    iana_timezone: "America/New_York",
  },
  {
    timerect: 1454,
    timereftime: 78,
    country: "Ireland",
    timestate: "",
    timecity: "Dublin",
    timediff: 0,
    timeZoneTimeAbbreviation: "EuropeIST",
    iana_timezone: "Europe/Dublin",
  },
  {
    timerect: 1455,
    timereftime: 421,
    country: "United States of America",
    timestate: "New York",
    timecity: "Rochester",
    timediff: -240,
    timeZoneTimeAbbreviation: "AmericaEST",
    iana_timezone: "America/New_York",
  },
  {
    timerect: 1456,
    timereftime: 110,
    country: "Israel",
    timestate: "",
    timecity: "Jerusalem",
    timediff: 120,
    timeZoneTimeAbbreviation: "AsiaIDT",
    iana_timezone: "Asia/Jerusalem",
  },
  {
    timerect: 1457,
    timereftime: 412,
    country: "United States of America",
    timestate: "North Carolina",
    timecity: "Charlotte",
    timediff: -300,
    timeZoneTimeAbbreviation: "AmericaEST",
    iana_timezone: "America/New_York",
  },
  {
    timerect: 1458,
    timereftime: 676,
    country: "Israel",
    timestate: "",
    timecity: "Tel Aviv",
    timediff: 120,
    timeZoneTimeAbbreviation: "AsiaIST",
    iana_timezone: "Asia/Jerusalem",
  },
  {
    timerect: 1459,
    timereftime: 207,
    country: "United States of America",
    timestate: "North Carolina",
    timecity: "Raleigh",
    timediff: -300,
    timeZoneTimeAbbreviation: "AmericaEST",
    iana_timezone: "America/New_York",
  },
  {
    timerect: 1460,
    timereftime: 157,
    country: "Italy",
    timestate: "",
    timecity: "Milan",
    timediff: 60,
    timeZoneTimeAbbreviation: "EuropeCET",
    iana_timezone: "Europe/Rome",
  },
  {
    timerect: 1461,
    timereftime: 39,
    country: "United States of America",
    timestate: "North Dakota",
    timecity: "Bismarck",
    timediff: -360,
    timeZoneTimeAbbreviation: "AmericaCST",
    iana_timezone: "America/Denver",
  },
  {
    timerect: 1462,
    timereftime: 172,
    country: "Italy",
    timestate: "",
    timecity: "Naples",
    timediff: 60,
    timeZoneTimeAbbreviation: "EuropeCET",
    iana_timezone: "Europe/Rome",
  },
  {
    timerect: 1463,
    timereftime: 934,
    country: "United States of America",
    timestate: "Northern Mariana Islands",
    timecity: "Saipan",
    timediff: 600,
    timeZoneTimeAbbreviation: "AmericaChST",
    iana_timezone: "Pacific/Guam",
  },
  {
    timerect: 1464,
    timereftime: 215,
    country: "Italy",
    timestate: "",
    timecity: "Rome",
    timediff: 60,
    timeZoneTimeAbbreviation: "EuropeCEST",
    iana_timezone: "Europe/Rome",
  },
  {
    timerect: 1465,
    timereftime: 415,
    country: "United States of America",
    timestate: "Ohio",
    timecity: "Akron",
    timediff: -300,
    timeZoneTimeAbbreviation: "AmericaEST",
    iana_timezone: "America/New_York",
  },
  {
    timerect: 1466,
    timereftime: 254,
    country: "Italy",
    timestate: "",
    timecity: "Turin",
    timediff: 60,
    timeZoneTimeAbbreviation: "EuropeCET",
    iana_timezone: "Europe/Rome",
  },
  {
    timerect: 1467,
    timereftime: 414,
    country: "United States of America",
    timestate: "Ohio",
    timecity: "Cincinnati",
    timediff: -300,
    timeZoneTimeAbbreviation: "AmericaEST",
    iana_timezone: "America/New_York",
  },
  {
    timerect: 1468,
    timereftime: 257,
    country: "Italy",
    timestate: "",
    timecity: "Venice",
    timediff: 60,
    timeZoneTimeAbbreviation: "EuropeCET",
    iana_timezone: "Europe/Rome",
  },
  {
    timerect: 1469,
    timereftime: 417,
    country: "United States of America",
    timestate: "Ohio",
    timecity: "Cleveland",
    timediff: -300,
    timeZoneTimeAbbreviation: "AmericaEST",
    iana_timezone: "America/New_York",
  },
  {
    timerect: 1470,
    timereftime: 120,
    country: "Jamaica",
    timestate: "",
    timecity: "Kingston",
    timediff: -300,
    timeZoneTimeAbbreviation: "AmericaEST",
    iana_timezone: "America/Jamaica",
  },
  {
    timerect: 1471,
    timereftime: 805,
    country: "United States of America",
    timestate: "Ohio",
    timecity: "Columbus",
    timediff: -300,
    timeZoneTimeAbbreviation: "AmericaEST",
    iana_timezone: "America/New_York",
  },
  {
    timerect: 1472,
    timereftime: 492,
    country: "Japan",
    timestate: "",
    timecity: "Fukuoka",
    timediff: 540,
    timeZoneTimeAbbreviation: "AsiaJST",
    iana_timezone: "Asia/Tokyo",
  },
  {
    timerect: 1473,
    timereftime: 416,
    country: "United States of America",
    timestate: "Ohio",
    timecity: "Toledo",
    timediff: -300,
    timeZoneTimeAbbreviation: "AmericaEST",
    iana_timezone: "America/New_York",
  },
  {
    timerect: 1474,
    timereftime: 1064,
    country: "Japan",
    timestate: "",
    timecity: "Hiroshima",
    timediff: 540,
    timeZoneTimeAbbreviation: "AsiaJST",
    iana_timezone: "Asia/Tokyo",
  },
  {
    timerect: 1475,
    timereftime: 184,
    country: "United States of America",
    timestate: "Oklahoma",
    timecity: "Oklahoma City",
    timediff: -360,
    timeZoneTimeAbbreviation: "AmericaCST",
    iana_timezone: "America/Chicago",
  },
  {
    timerect: 1476,
    timereftime: 530,
    country: "Japan",
    timestate: "",
    timecity: "Kawasaki",
    timediff: 540,
    timeZoneTimeAbbreviation: "AsiaJST",
    iana_timezone: "Asia/Tokyo",
  },
  {
    timerect: 1477,
    timereftime: 202,
    country: "United States of America",
    timestate: "Oregon",
    timecity: "Portland",
    timediff: -480,
    timeZoneTimeAbbreviation: "AmericaPST",
    iana_timezone: "America/Los_Angeles",
  },
  {
    timerect: 1478,
    timereftime: 532,
    country: "Japan",
    timestate: "",
    timecity: "Kitakyushu",
    timediff: 540,
    timeZoneTimeAbbreviation: "AsiaJST",
    iana_timezone: "Asia/Tokyo",
  },
  {
    timerect: 1479,
    timereftime: 221,
    country: "United States of America",
    timestate: "Oregon",
    timecity: "Salem",
    timediff: -480,
    timeZoneTimeAbbreviation: "AmericaPST",
    iana_timezone: "America/Los_Angeles",
  },
  {
    timerect: 1480,
    timereftime: 540,
    country: "Japan",
    timestate: "",
    timecity: "Kobe",
    timediff: 540,
    timeZoneTimeAbbreviation: "AsiaJST",
    iana_timezone: "Asia/Tokyo",
  },
  {
    timerect: 1481,
    timereftime: 97,
    country: "United States of America",
    timestate: "Pennsylvania",
    timecity: "Harrisburg",
    timediff: -300,
    timeZoneTimeAbbreviation: "AmericaEST",
    iana_timezone: "America/New_York",
  },
  {
    timerect: 1482,
    timereftime: 538,
    country: "Japan",
    timestate: "",
    timecity: "Kyoto",
    timediff: 540,
    timeZoneTimeAbbreviation: "AsiaJST",
    iana_timezone: "Asia/Tokyo",
  },
  {
    timerect: 1483,
    timereftime: 198,
    country: "United States of America",
    timestate: "Pennsylvania",
    timecity: "Philadelphia",
    timediff: -300,
    timeZoneTimeAbbreviation: "AmericaEST",
    iana_timezone: "America/New_York",
  },
  {
    timerect: 1484,
    timereftime: 565,
    country: "Japan",
    timestate: "",
    timecity: "Nagoya",
    timediff: 540,
    timeZoneTimeAbbreviation: "AsiaJST",
    iana_timezone: "Asia/Tokyo",
  },
  {
    timerect: 1485,
    timereftime: 418,
    country: "United States of America",
    timestate: "Pennsylvania",
    timecity: "Pittsburgh",
    timediff: -240,
    timeZoneTimeAbbreviation: "AmericaEST",
    iana_timezone: "America/New_York",
  },
  {
    timerect: 1486,
    timereftime: 1066,
    country: "Japan",
    timestate: "",
    timecity: "Okayama",
    timediff: 540,
    timeZoneTimeAbbreviation: "AsiaJST",
    iana_timezone: "Asia/Tokyo",
  },
  {
    timerect: 1487,
    timereftime: 878,
    country: "United States of America",
    timestate: "Rhode Island",
    timecity: "Providence",
    timediff: -300,
    timeZoneTimeAbbreviation: "AmericaEST",
    iana_timezone: "America/New_York",
  },
  {
    timerect: 1488,
    timereftime: 671,
    country: "Japan",
    timestate: "",
    timecity: "Osaka",
    timediff: 540,
    timeZoneTimeAbbreviation: "AsiaJST",
    iana_timezone: "Asia/Tokyo",
  },
  {
    timerect: 1489,
    timereftime: 66,
    country: "United States of America",
    timestate: "South Carolina",
    timecity: "Columbia",
    timediff: -300,
    timeZoneTimeAbbreviation: "AmericaEST",
    iana_timezone: "America/New_York",
  },
  {
    timerect: 1490,
    timereftime: 622,
    country: "Japan",
    timestate: "",
    timecity: "Sapporo",
    timediff: 540,
    timeZoneTimeAbbreviation: "AsiaJST",
    iana_timezone: "Asia/Tokyo",
  },
  {
    timerect: 1491,
    timereftime: 200,
    country: "United States of America",
    timestate: "South Dakota",
    timecity: "Pierre",
    timediff: -360,
    timeZoneTimeAbbreviation: "AmericaCST",
    iana_timezone: "America/Denver",
  },
  {
    timerect: 1492,
    timereftime: 1065,
    country: "Japan",
    timestate: "",
    timecity: "Sendai",
    timediff: 540,
    timeZoneTimeAbbreviation: "AsiaJST",
    iana_timezone: "Asia/Tokyo",
  },
  {
    timerect: 1493,
    timereftime: 627,
    country: "United States of America",
    timestate: "South Dakota",
    timecity: "Sioux Falls",
    timediff: -360,
    timeZoneTimeAbbreviation: "AmericaCST",
    iana_timezone: "America/Chicago",
  },
  {
    timerect: 1494,
    timereftime: 248,
    country: "Japan",
    timestate: "",
    timecity: "Tokyo",
    timediff: 540,
    timeZoneTimeAbbreviation: "AsiaJST",
    iana_timezone: "Asia/Tokyo",
  },
  {
    timerect: 1495,
    timereftime: 843,
    country: "United States of America",
    timestate: "Tennessee",
    timecity: "Knoxville",
    timediff: -240,
    timeZoneTimeAbbreviation: "AmericaEST",
    iana_timezone: "America/New_York",
  },
  {
    timerect: 1496,
    timereftime: 667,
    country: "Japan",
    timestate: "",
    timecity: "Yokohama",
    timediff: 540,
    timeZoneTimeAbbreviation: "AsiaJST",
    iana_timezone: "Asia/Tokyo",
  },
  {
    timerect: 1497,
    timereftime: 409,
    country: "United States of America",
    timestate: "Tennessee",
    timecity: "Memphis",
    timediff: -360,
    timeZoneTimeAbbreviation: "AmericaCST",
    iana_timezone: "America/Chicago",
  },
  {
    timerect: 1498,
    timereftime: 11,
    country: "Jordan",
    timestate: "",
    timecity: "Amman",
    timediff: 180,
    timeZoneTimeAbbreviation: "AsiaEEST",
    iana_timezone: "Asia/Amman",
  },
  {
    timerect: 1499,
    timereftime: 171,
    country: "United States of America",
    timestate: "Tennessee",
    timecity: "Nashville",
    timediff: -360,
    timeZoneTimeAbbreviation: "AmericaCST",
    iana_timezone: "America/Chicago",
  },
  {
    timerect: 1500,
    timereftime: 382,
    country: "Kazakstan",
    timestate: "",
    timecity: "Almaty",
    timediff: 360,
    timeZoneTimeAbbreviation: "AsiaALMT",
    iana_timezone: "Asia/Almaty",
  },
  {
    timerect: 1501,
    timereftime: 786,
    country: "United States of America",
    timestate: "Texas",
    timecity: "Arlington",
    timediff: -300,
    timeZoneTimeAbbreviation: "AmericaCST",
    iana_timezone: "America/Chicago",
  },
  {
    timerect: 1502,
    timereftime: 917,
    country: "Kazakstan",
    timestate: "",
    timecity: "Aqtau",
    timediff: 300,
    timeZoneTimeAbbreviation: "AsiaALMT",
    iana_timezone: "Asia/Aqtau",
  },
  {
    timerect: 1503,
    timereftime: 24,
    country: "United States of America",
    timestate: "Texas",
    timecity: "Austin",
    timediff: -360,
    timeZoneTimeAbbreviation: "AmericaCST",
    iana_timezone: "America/Chicago",
  },
  {
    timerect: 1504,
    timereftime: 916,
    country: "Kazakstan",
    timestate: "",
    timecity: "Aqtobe",
    timediff: 300,
    timeZoneTimeAbbreviation: "AsiaALMT",
    iana_timezone: "Asia/Aqtobe",
  },
  {
    timerect: 1505,
    timereftime: 70,
    country: "United States of America",
    timestate: "Texas",
    timecity: "Dallas",
    timediff: -360,
    timeZoneTimeAbbreviation: "AmericaCST",
    iana_timezone: "America/Chicago",
  },
  {
    timerect: 1506,
    timereftime: 921,
    country: "Kazakstan",
    timestate: "",
    timecity: "Astana",
    timediff: 360,
    timeZoneTimeAbbreviation: "AsiaALMT",
    iana_timezone: "Asia/Almaty",
  },
  {
    timerect: 1507,
    timereftime: 395,
    country: "United States of America",
    timestate: "Texas",
    timecity: "El Paso",
    timediff: -420,
    timeZoneTimeAbbreviation: "AmericaMST",
    iana_timezone: "America/Denver",
  },
  {
    timerect: 1508,
    timereftime: 170,
    country: "Kenya",
    timestate: "",
    timecity: "Nairobi",
    timediff: 180,
    timeZoneTimeAbbreviation: "AfricaEAT",
    iana_timezone: "Africa/Nairobi",
  },
  {
    timerect: 1509,
    timereftime: 401,
    country: "United States of America",
    timestate: "Texas",
    timecity: "Fort Worth",
    timediff: -300,
    timeZoneTimeAbbreviation: "AmericaCST",
    iana_timezone: "America/Chicago",
  },
  {
    timerect: 1510,
    timereftime: 274,
    country: "Kiribati",
    timestate: "Christmas Islands",
    timecity: "Kiritimati",
    timediff: 840,
    timeZoneTimeAbbreviation: "PacificLINT",
    iana_timezone: "Pacific/Kiritimati",
  },
  {
    timerect: 1511,
    timereftime: 104,
    country: "United States of America",
    timestate: "Texas",
    timecity: "Houston",
    timediff: -360,
    timeZoneTimeAbbreviation: "AmericaCST",
    iana_timezone: "America/Chicago",
  },
  {
    timerect: 1512,
    timereftime: 713,
    country: "Kiribati",
    timestate: "Phoenix Islands",
    timecity: "Rawaki",
    timediff: 780,
    timeZoneTimeAbbreviation: "AustraliaPHOT",
    iana_timezone: "Pacific/Tarawa",
  },
  {
    timerect: 1513,
    timereftime: 400,
    country: "United States of America",
    timestate: "Texas",
    timecity: "San Antonio",
    timediff: -300,
    timeZoneTimeAbbreviation: "AmericaCST",
    iana_timezone: "America/Chicago",
  },
  {
    timerect: 1514,
    timereftime: 675,
    country: "Kiribati",
    timestate: "",
    timecity: "Tarawa",
    timediff: 720,
    timeZoneTimeAbbreviation: "PacificGILT",
    iana_timezone: "Pacific/Tarawa",
  },
  {
    timerect: 1515,
    timereftime: 220,
    country: "United States of America",
    timestate: "Utah",
    timecity: "Salt Lake City",
    timediff: -420,
    timeZoneTimeAbbreviation: "AmericaMST",
    iana_timezone: "America/Denver",
  },
  {
    timerect: 1516,
    timereftime: 123,
    country: "Kuwait",
    timestate: "",
    timecity: "Kuwait City",
    timediff: 180,
    timeZoneTimeAbbreviation: "AsiaKWT",
    iana_timezone: "Asia/Kuwait",
  },
  {
    timerect: 1517,
    timereftime: 164,
    country: "United States of America",
    timestate: "Vermont",
    timecity: "Montpelier",
    timediff: -300,
    timeZoneTimeAbbreviation: "AmericaEST",
    iana_timezone: "America/New_York",
  },
  {
    timerect: 1518,
    timereftime: 384,
    country: "Kyrgyzstan",
    timestate: "",
    timecity: "Bishkek",
    timediff: 360,
    timeZoneTimeAbbreviation: "AsiaKGT",
    iana_timezone: "Asia/Bishkek",
  },
  {
    timerect: 1519,
    timereftime: 420,
    country: "United States of America",
    timestate: "Virginia",
    timecity: "Norfolk",
    timediff: -240,
    timeZoneTimeAbbreviation: "AmericaEST",
    iana_timezone: "America/New_York",
  },
  {
    timerect: 1520,
    timereftime: 260,
    country: "Laos",
    timestate: "",
    timecity: "Vientiane",
    timediff: 420,
    timeZoneTimeAbbreviation: "AsiaICT",
    iana_timezone: "Asia/Vientiane",
  },
  {
    timerect: 1521,
    timereftime: 212,
    country: "United States of America",
    timestate: "Virginia",
    timecity: "Richmond",
    timediff: -300,
    timeZoneTimeAbbreviation: "AmericaEST",
    iana_timezone: "America/New_York",
  },
  {
    timerect: 1522,
    timereftime: 602,
    country: "Latvia",
    timestate: "",
    timecity: "Riga",
    timediff: 120,
    timeZoneTimeAbbreviation: "EuropeEEST",
    iana_timezone: "Europe/Riga",
  },
  {
    timerect: 1523,
    timereftime: 904,
    country: "United States of America",
    timestate: "Virginia",
    timecity: "Virginia Beach",
    timediff: -300,
    timeZoneTimeAbbreviation: "AmericaEST",
    iana_timezone: "America/New_York",
  },
  {
    timerect: 1524,
    timereftime: 34,
    country: "Lebanon",
    timestate: "",
    timecity: "Beirut",
    timediff: 120,
    timeZoneTimeAbbreviation: "AsiaEEST",
    iana_timezone: "Asia/Beirut",
  },
  {
    timerect: 1525,
    timereftime: 234,
    country: "United States of America",
    timestate: "Washington",
    timecity: "Seattle",
    timediff: -480,
    timeZoneTimeAbbreviation: "AmericaPST",
    iana_timezone: "America/Los_Angeles",
  },
  {
    timerect: 1526,
    timereftime: 147,
    country: "Lesotho",
    timestate: "",
    timecity: "Maseru",
    timediff: 120,
    timeZoneTimeAbbreviation: "AfricaSAST",
    iana_timezone: "Africa/Maseru",
  },
  {
    timerect: 1527,
    timereftime: 62,
    country: "United States of America",
    timestate: "West Virginia",
    timecity: "Charleston",
    timediff: -300,
    timeZoneTimeAbbreviation: "AmericaEST",
    iana_timezone: "America/New_York",
  },
  {
    timerect: 1528,
    timereftime: 161,
    country: "Liberia",
    timestate: "",
    timecity: "Monrovia",
    timediff: 0,
    timeZoneTimeAbbreviation: "AfricaGMT",
    iana_timezone: "Africa/Monrovia",
  },
  {
    timerect: 1529,
    timereftime: 142,
    country: "United States of America",
    timestate: "Wisconsin",
    timecity: "Madison",
    timediff: -360,
    timeZoneTimeAbbreviation: "AmericaCST",
    iana_timezone: "America/Chicago",
  },
  {
    timerect: 1530,
    timereftime: 252,
    country: "Libya",
    timestate: "",
    timecity: "Tripoli",
    timediff: 120,
    timeZoneTimeAbbreviation: "AfricaEET",
    iana_timezone: "Africa/Tripoli",
  },
  {
    timerect: 1531,
    timereftime: 158,
    country: "United States of America",
    timestate: "Wisconsin",
    timecity: "Milwaukee",
    timediff: -360,
    timeZoneTimeAbbreviation: "AmericaCST",
    iana_timezone: "America/Chicago",
  },
  {
    timerect: 1532,
    timereftime: 714,
    country: "Liechtenstein",
    timestate: "",
    timecity: "Vaduz",
    timediff: 60,
    timeZoneTimeAbbreviation: "EuropeCEST",
    iana_timezone: "Europe/Zurich",
  },
  {
    timerect: 1533,
    timereftime: 778,
    country: "United States of America",
    timestate: "Wyoming",
    timecity: "Cheyenne",
    timediff: -420,
    timeZoneTimeAbbreviation: "AmericaMST",
    iana_timezone: "America/Denver",
  },
  {
    timerect: 1534,
    timereftime: 529,
    country: "Lithuania",
    timestate: "",
    timecity: "Kaunas",
    timediff: 120,
    timeZoneTimeAbbreviation: "EuropeEET",
    iana_timezone: "Europe/Vilnius",
  },
  {
    timerect: 1535,
    timereftime: 115,
    country: "Uganda",
    timestate: "",
    timecity: "Kampala",
    timediff: 180,
    timeZoneTimeAbbreviation: "AfricaEAT",
    iana_timezone: "Africa/Kampala",
  },
  {
    timerect: 1536,
    timereftime: 660,
    country: "Lithuania",
    timestate: "",
    timecity: "Vilnius",
    timediff: 120,
    timeZoneTimeAbbreviation: "EuropeEEST",
    iana_timezone: "Europe/Vilnius",
  },
  {
    timerect: 1537,
    timereftime: 367,
    country: "Ukraine",
    timestate: "",
    timecity: "Kyiv",
    timediff: 120,
    timeZoneTimeAbbreviation: "EuropeEEST",
    iana_timezone: "Europe/Kyiv",
  },
  {
    timerect: 1538,
    timereftime: 534,
    country: "Luxembourg",
    timestate: "",
    timecity: "Luxembourg",
    timediff: 60,
    timeZoneTimeAbbreviation: "EuropeCEST",
    iana_timezone: "Europe/Luxembourg",
  },
  {
    timerect: 1539,
    timereftime: 366,
    country: "Ukraine",
    timestate: "",
    timecity: "Odesa",
    timediff: 120,
    timeZoneTimeAbbreviation: "EuropeEET",
    iana_timezone: "Europe/Kyiv",
  },
  {
    timerect: 1540,
    timereftime: 673,
    country: "Macedonia",
    timestate: "",
    timecity: "Skopje",
    timediff: 60,
    timeZoneTimeAbbreviation: "EuropeCEST",
    iana_timezone: "Europe/Skopje",
  },
  {
    timerect: 1541,
    timereftime: 2,
    country: "United Arab Emirates",
    timestate: "",
    timecity: "Abu Dhabi",
    timediff: 240,
    timeZoneTimeAbbreviation: "AsiaGST",
    iana_timezone: "Asia/Dubai",
  },
  {
    timerect: 1542,
    timereftime: 20,
    country: "Madagascar",
    timestate: "",
    timecity: "Antananarivo",
    timediff: 180,
    timeZoneTimeAbbreviation: "AfricaEAT",
    iana_timezone: "Indian/Antananarivo",
  },
  {
    timerect: 1543,
    timereftime: 776,
    country: "United Arab Emirates",
    timestate: "",
    timecity: "Dubai",
    timediff: 240,
    timeZoneTimeAbbreviation: "AsiaGST",
    iana_timezone: "Asia/Dubai",
  },
  {
    timerect: 1544,
    timereftime: 130,
    country: "Malawi",
    timestate: "",
    timecity: "Lilongwe",
    timediff: 120,
    timeZoneTimeAbbreviation: "AfricaCAT",
    iana_timezone: "Africa/Blantyre",
  },
  {
    timerect: 1545,
    timereftime: 163,
    country: "Uruguay",
    timestate: "",
    timecity: "Montevideo",
    timediff: -120,
    timeZoneTimeAbbreviation: "AmericaUYT",
    iana_timezone: "America/Montevideo",
  },
  {
    timerect: 1546,
    timereftime: 122,
    country: "Malaysia",
    timestate: "",
    timecity: "Kuala Lumpur",
    timediff: 480,
    timeZoneTimeAbbreviation: "AsiaMYT",
    iana_timezone: "Asia/Kuala_Lumpur",
  },
  {
    timerect: 1547,
    timereftime: 244,
    country: "Uzbekistan",
    timestate: "",
    timecity: "Tashkent",
    timediff: 300,
    timeZoneTimeAbbreviation: "AsiaUZT",
    iana_timezone: "Asia/Tashkent",
  },
  {
    timerect: 1548,
    timereftime: 29,
    country: "Mali",
    timestate: "",
    timecity: "Bamako",
    timediff: 0,
    timeZoneTimeAbbreviation: "AfricaGMT",
    iana_timezone: "Africa/Bamako",
  },
  {
    timerect: 1549,
    timereftime: 280,
    country: "Vanuatu",
    timestate: "",
    timecity: "Vila",
    timediff: 660,
    timeZoneTimeAbbreviation: "PacificVUT",
    iana_timezone: "Pacific/Efate",
  },
  {
    timerect: 1550,
    timereftime: 255,
    country: "Malta",
    timestate: "",
    timecity: "Valletta",
    timediff: 60,
    timeZoneTimeAbbreviation: "EuropeCET",
    iana_timezone: "Europe/Malta",
  },
  {
    timerect: 1551,
    timereftime: 710,
    country: "Vatican City State",
    timestate: "",
    timecity: "Vatican City",
    timediff: 60,
    timeZoneTimeAbbreviation: "EuropeCET",
    iana_timezone: "Europe/Rome",
  },
  {
    timerect: 1552,
    timereftime: 183,
    country: "Mauritania",
    timestate: "",
    timecity: "Nouakchott",
    timediff: 0,
    timeZoneTimeAbbreviation: "AfricaGMT",
    iana_timezone: "Africa/Nouakchott",
  },
  {
    timerect: 1553,
    timereftime: 58,
    country: "Venezuela",
    timestate: "",
    timecity: "Caracas",
    timediff: -270,
    timeZoneTimeAbbreviation: "AmericaVET",
    iana_timezone: "America/Caracas",
  },
  {
    timerect: 1554,
    timereftime: 201,
    country: "Mauritius",
    timestate: "",
    timecity: "Port Louis",
    timediff: 240,
    timeZoneTimeAbbreviation: "AfricaMUT",
    iana_timezone: "Indian/Mauritius",
  },
  {
    timerect: 1555,
    timereftime: 95,
    country: "Vietnam",
    timestate: "",
    timecity: "Hanoi",
    timediff: 420,
    timeZoneTimeAbbreviation: "AsiaICT",
    iana_timezone: "Asia/Ho_Chi_Minh",
  },
  {
    timerect: 1556,
    timereftime: 3,
    country: "Mexico",
    timestate: "",
    timecity: "Acapulco",
    timediff: -360,
    timeZoneTimeAbbreviation: "AmericaCDT",
    iana_timezone: "America/Mexico_City",
  },
  {
    timerect: 1557,
    timereftime: 218,
    country: "Vietnam",
    timestate: "",
    timecity: "Ho Chi Minh",
    timediff: 420,
    timeZoneTimeAbbreviation: "AsiaICT",
    iana_timezone: "Asia/Ho_Chi_Minh",
  },
  {
    timerect: 1558,
    timereftime: 9,
    country: "Mexico",
    timestate: "",
    timecity: "Aguascalientes",
    timediff: -360,
    timeZoneTimeAbbreviation: "AmericaCDT",
    iana_timezone: "America/Mexico_City",
  },
  {
    timerect: 1559,
    timereftime: 1048,
    country: "West Bank",
    timestate: "",
    timecity: "Bethlehem",
    timediff: 120,
    timeZoneTimeAbbreviation: "EuropeEET",
    iana_timezone: "Asia/Jerusalem",
  },
  {
    timerect: 1560,
    timereftime: 923,
    country: "Mexico",
    timestate: "",
    timecity: "Cancún",
    timediff: -360,
    timeZoneTimeAbbreviation: "AmericaCDT",
    iana_timezone: "America/Cancun",
  },
  {
    timerect: 1561,
    timereftime: 741,
    country: "Western Sahara",
    timestate: "",
    timecity: "El Aaiún",
    timediff: 0,
    timeZoneTimeAbbreviation: "EuropeWET",
    iana_timezone: "Africa/El_Aaiun",
  },
  {
    timerect: 1562,
    timereftime: 65,
    country: "Mexico",
    timestate: "",
    timecity: "Chihuahua",
    timediff: -420,
    timeZoneTimeAbbreviation: "AmericaMDT",
    iana_timezone: "America/Chihuahua",
  },
  {
    timerect: 1563,
    timereftime: 6,
    country: "Yemen",
    timestate: "",
    timecity: "Aden",
    timediff: 180,
    timeZoneTimeAbbreviation: "AsiaAST",
    iana_timezone: "Asia/Aden",
  },
  {
    timerect: 1564,
    timereftime: 92,
    country: "Mexico",
    timestate: "",
    timecity: "Guadalajara",
    timediff: -360,
    timeZoneTimeAbbreviation: "AmericaCST",
    iana_timezone: "America/Mexico_City",
  },
  {
    timerect: 1565,
    timereftime: 672,
    country: "Yemen",
    timestate: "",
    timecity: "Sana",
    timediff: 180,
    timeZoneTimeAbbreviation: "AsiaYEMT",
    iana_timezone: "Asia/Aden",
  },
  {
    timerect: 1566,
    timereftime: 128,
    country: "Mexico",
    timestate: "",
    timecity: "Leon",
    timediff: -360,
    timeZoneTimeAbbreviation: "AmericaCST",
    iana_timezone: "America/Mexico_City",
  },
  {
    timerect: 1567,
    timereftime: 140,
    country: "Zambia",
    timestate: "",
    timecity: "Lusaka",
    timediff: 120,
    timeZoneTimeAbbreviation: "AfricaCAT",
    iana_timezone: "Africa/Lusaka",
  },
  {
    timerect: 1568,
    timereftime: 148,
    country: "Mexico",
    timestate: "",
    timecity: "Mazatlan",
    timediff: -420,
    timeZoneTimeAbbreviation: "AmericaMDT",
    iana_timezone: "America/Mazatlan",
  },
  {
    timerect: 1569,
    timereftime: 96,
    country: "Zimbabwe",
    timestate: "",
    timecity: "Harare",
    timediff: 120,
    timeZoneTimeAbbreviation: "AfricaCAT",
    iana_timezone: "Africa/Harare",
  },
  {
    timerect: 1570,
    timereftime: 153,
    country: "Mexico",
    timestate: "",
    timecity: "Merida",
    timediff: -360,
    timeZoneTimeAbbreviation: "AmericaCDT",
    iana_timezone: "America/Merida",
  },
];
